
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("RPX28", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a1d3fc4d03b5450$export$2e2bcd8739ae039; });

var $Zqzri = parcelRequire("Zqzri");

var $glJen = parcelRequire("glJen");

var $y8mkn = parcelRequire("y8mkn");

var $9Ecwd = parcelRequire("9Ecwd");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $fO5Qk = parcelRequire("fO5Qk");

var $cDjyV = parcelRequire("cDjyV");

var $4OZuI = parcelRequire("4OZuI");

var $kXNP1 = parcelRequire("kXNP1");

var $6Qn9B = parcelRequire("6Qn9B");

var $5YuF5 = parcelRequire("5YuF5");

var $eCrfe = parcelRequire("eCrfe");

var $6222Z = parcelRequire("6222Z");

var $akIMk = parcelRequire("akIMk");

var $a8ppI = parcelRequire("a8ppI");

var $gY9aX = parcelRequire("gY9aX");

var $kbnBK = parcelRequire("kbnBK");

var $cCyPX = parcelRequire("cCyPX");

var $ajQGf = parcelRequire("ajQGf");
var $0a1d3fc4d03b5450$var$_excluded = [
    "aria-controls",
    "aria-expanded",
    "aria-haspopup",
    "onClick"
];
function $0a1d3fc4d03b5450$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a1d3fc4d03b5450$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a1d3fc4d03b5450$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a1d3fc4d03b5450$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0a1d3fc4d03b5450$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $0a1d3fc4d03b5450$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: $0a1d3fc4d03b5450$var$_objectSpread({
            render: function render(Component, props, index) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Component, (0, $y8mkn.default)({}, props, {
                    key: (0, $ajQGf.composeUniqueKey)(props.avatar, index)
                }));
            }
        }, overrides && overrides.AvatarGroupItem),
        Avatar: $0a1d3fc4d03b5450$var$_objectSpread({
            render: function render(Component, props, index) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Component, (0, $y8mkn.default)({}, props, {
                    key: (0, $ajQGf.composeUniqueKey)(props, index)
                }));
            }
        }, overrides && overrides.Avatar),
        MoreIndicator: $0a1d3fc4d03b5450$var$_objectSpread({
            render: function render(Component, props) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Component, props);
            }
        }, overrides && overrides.MoreIndicator)
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ var $0a1d3fc4d03b5450$var$AvatarGroup = function AvatarGroup(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "stack" : _ref$appearance, _ref$avatar = _ref.avatar, avatar = _ref$avatar === void 0 ? (0, $fO5Qk.default) : _ref$avatar, borderColor = _ref.borderColor, boundariesElement = _ref.boundariesElement, data = _ref.data, isTooltipDisabled = _ref.isTooltipDisabled, maxCount = _ref.maxCount, onAvatarClick = _ref.onAvatarClick, onMoreClick = _ref.onMoreClick, overrides = _ref.overrides, _ref$showMoreButtonPr = _ref.showMoreButtonProps, showMoreButtonProps = _ref$showMoreButtonPr === void 0 ? {} : _ref$showMoreButtonPr, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId, _ref$label = _ref.label, label = _ref$label === void 0 ? "avatar group" : _ref$label, _ref$tooltipPosition = _ref.tooltipPosition, tooltipPosition = _ref$tooltipPosition === void 0 ? "bottom" : _ref$tooltipPosition, _ref$shouldPopupRende = _ref.shouldPopupRenderToParent, shouldPopupRenderToParent = _ref$shouldPopupRende === void 0 ? false : _ref$shouldPopupRende;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $glJen.default)(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(false), _useState4 = (0, $glJen.default)(_useState3, 2), isOpen = _useState4[0], setIsOpen = _useState4[1];
    var onClose = (0, $iSvIT.useCallback)(function() {
        return setIsOpen(false);
    }, []);
    var handleTriggerClicked = (0, $iSvIT.useCallback)(function(event) {
        var _ref2 = event, clientX = _ref2.clientX, clientY = _ref2.clientY, type = _ref2.type;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === "keydown" || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen(function(isOpen) {
            return !isOpen;
        });
    }, []);
    var _useFocus = (0, $kXNP1.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $iSvIT.useEffect)(function() {
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $4OZuI.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $4OZuI.default;
        (0, $2e1kT.bind)(window, {
            type: "keydown",
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $cDjyV.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        var unbind = function unbind() {
            (0, $2e1kT.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $cDjyV.KEY_DOWN)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        var renderMoreButton = function renderMoreButton(_ref3) {
            var ariaControls = _ref3["aria-controls"], ariaExpanded = _ref3["aria-expanded"], ariaHasPopup = _ref3["aria-haspopup"], onClick = _ref3.onClick, props = (0, $Zqzri.default)(_ref3, $0a1d3fc4d03b5450$var$_excluded);
            return $0a1d3fc4d03b5450$var$getOverrides(overrides).MoreIndicator.render((0, $kbnBK.default), $0a1d3fc4d03b5450$var$_objectSpread({
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && "".concat(testId, "--overflow-menu--trigger"),
                isActive: isOpen,
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                onClick: onClick
            }, props));
        };
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === "function") return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        var boundary = boundariesElement === "scrollParent" ? "clippingParents" : undefined;
        var rootBoundary = function() {
            if (boundariesElement === "scrollParent") return undefined;
            return boundariesElement === "window" ? "document" : "viewport";
        }();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5YuF5.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: function content(_ref4) {
                var setInitialFocusRef = _ref4.setInitialFocusRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a8ppI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gY9aX.default), {
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6Qn9B.default), null, data.slice(max).map(function(avatar, index) {
                    return $0a1d3fc4d03b5450$var$getOverrides(overrides).AvatarGroupItem.render((0, $6222Z.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && "".concat(testId, "--avatar-group-item-").concat(index + max),
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max);
                }))));
            },
            trigger: function trigger(triggerProps) {
                return renderMoreButton($0a1d3fc4d03b5450$var$_objectSpread($0a1d3fc4d03b5450$var$_objectSpread($0a1d3fc4d03b5450$var$_objectSpread({}, triggerProps), bindFocus), {}, {
                    onClick: handleTriggerClicked
                }));
            },
            testId: testId && "".concat(testId, "--overflow-menu")
        });
    }
    var max = maxCount === undefined || maxCount === 0 ? $0a1d3fc4d03b5450$var$MAX_COUNT[appearance] : maxCount;
    var total = data.length;
    var maxAvatar = total > max ? max - 1 : max;
    var Group = appearance === "stack" ? (0, $cCyPX.default) : (0, $akIMk.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Group, {
        testId: testId && "".concat(testId, "--avatar-group"),
        "aria-label": label
    }, data.slice(0, maxAvatar).map(function(avatarData, idx) {
        var callback = avatarData.onClick || onAvatarClick;
        var finalAvatar = $0a1d3fc4d03b5450$var$getOverrides(overrides).Avatar.render(avatar, $0a1d3fc4d03b5450$var$_objectSpread($0a1d3fc4d03b5450$var$_objectSpread({}, avatarData), {}, {
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && "".concat(testId, "--avatar-").concat(idx),
            onClick: callback ? function(event, analyticsEvent) {
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }), idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eCrfe.default), {
            key: (0, $ajQGf.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && "".concat(testId, "--tooltip-").concat(idx),
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $0a1d3fc4d03b5450$export$2e2bcd8739ae039 = $0a1d3fc4d03b5450$var$AvatarGroup;

});
parcelRegister("fO5Qk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8200ed354533e72$export$2e2bcd8739ae039; });

var $9Ecwd = parcelRequire("9Ecwd");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $l2DxG = parcelRequire("l2DxG");

var $dWwnB = parcelRequire("dWwnB");

var $aBDec = parcelRequire("aBDec");

var $15D8Q = parcelRequire("15D8Q");

var $eMgAN = parcelRequire("eMgAN");

var $eNnAt = parcelRequire("eNnAt");

var $4RZ47 = parcelRequire("4RZ47");

var $9bEFI = parcelRequire("9bEFI");
function $b8200ed354533e72$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b8200ed354533e72$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b8200ed354533e72$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b8200ed354533e72$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b8200ed354533e72$var$packageName = "@atlaskit/avatar";
var $b8200ed354533e72$var$packageVersion = "23.0.0";
var $b8200ed354533e72$var$containerStyles = (0, $2ZUkg.css)({
    display: "inline-block",
    position: "relative",
    outline: 0
});
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $b8200ed354533e72$var$Avatar = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "circle" : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? "div" : _ref$as;
    var _useAnalyticsEvents = (0, $l2DxG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $15D8Q.useAvatarContext)();
    var size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || "medium";
    var customPresenceNode = /*#__PURE__*/ (0, $iSvIT.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $iSvIT.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== "xxlarge" && size !== "xsmall";
    var lastAnalytics = (0, $iSvIT.useRef)(analyticsContext);
    var labelId = (0, $dWwnB.useId)();
    (0, $iSvIT.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $iSvIT.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== "function") return;
        var analyticsEvent = createAnalyticsEvent({
            action: "clicked",
            actionSubject: "avatar",
            attributes: {
                componentName: "avatar",
                packageName: $b8200ed354533e72$var$packageName,
                packageVersion: $b8200ed354533e72$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $b8200ed354533e72$var$_objectSpread({
            componentName: "avatar",
            packageName: $b8200ed354533e72$var$packageName,
            packageVersion: $b8200ed354533e72$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(" ");
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return (0, $2ZUkg.jsx)((0, $15D8Q.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, (0, $2ZUkg.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? "img" : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        css: $b8200ed354533e72$var$containerStyles,
        style: {
            zIndex: stackIndex
        }
    }, (0, $2ZUkg.jsx)((0, $15D8Q.AvatarContentContext).Provider, {
        value: {
            as: (0, $9bEFI.getCustomElement)(isDisabled, href, onClick),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            avatarImage: (0, $2ZUkg.jsx)((0, $eMgAN.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId
            })
        }
    }, children || (0, $2ZUkg.jsx)((0, $aBDec.AvatarContent), null)), isPresence && (0, $2ZUkg.jsx)((0, $eNnAt.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === "string" ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $2ZUkg.jsx)((0, $4RZ47.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === "string" ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? (0, $2ZUkg.jsx)("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$b8200ed354533e72$var$Avatar.displayName = "Avatar";
var $b8200ed354533e72$export$2e2bcd8739ae039 = $b8200ed354533e72$var$Avatar;

});
parcelRegister("l2DxG", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $f5187522508f9f39$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $gQSEi = parcelRequire("gQSEi");

var $22fiO = parcelRequire("22fiO");
function $f5187522508f9f39$export$5bf35293e545f20c() {
    var analyticsContext = (0, $22fiO.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $gQSEi.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("gQSEi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c44be4d2b4d0f980$export$2e2bcd8739ae039; });

var $2eRSM = parcelRequire("2eRSM");

var $39vnG = parcelRequire("39vnG");

var $1atGc = parcelRequire("1atGc");

var $gppMV = parcelRequire("gppMV");

var $fvHNj = parcelRequire("fvHNj");

var $f6TjO = parcelRequire("f6TjO");

var $5ziEL = parcelRequire("5ziEL");

var $9Ecwd = parcelRequire("9Ecwd");

var $knwYJ = parcelRequire("knwYJ");
function $c44be4d2b4d0f980$var$_callSuper(t, o, e) {
    return o = (0, $fvHNj.default)(o), (0, $gppMV.default)(t, $c44be4d2b4d0f980$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $fvHNj.default)(t).constructor) : o.apply(t, e));
}
function $c44be4d2b4d0f980$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c44be4d2b4d0f980$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c44be4d2b4d0f980$var$_superPropGet(t, o, e, r) {
    var p = (0, $f6TjO.default)((0, $fvHNj.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $c44be4d2b4d0f980$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c44be4d2b4d0f980$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $c44be4d2b4d0f980$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $39vnG.default)(this, UIAnalyticsEvent);
        _this = $c44be4d2b4d0f980$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $9Ecwd.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $9Ecwd.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $2eRSM.default)(_this.context);
            var handlers = (0, $2eRSM.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $9Ecwd.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $5ziEL.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $1atGc.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $c44be4d2b4d0f980$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $knwYJ.default));

});
parcelRegister("knwYJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed5f897553ea7ee3$export$2e2bcd8739ae039; });

var $47JGX = parcelRequire("47JGX");

var $39vnG = parcelRequire("39vnG");

var $1atGc = parcelRequire("1atGc");

var $9Ecwd = parcelRequire("9Ecwd");
function $ed5f897553ea7ee3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed5f897553ea7ee3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed5f897553ea7ee3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed5f897553ea7ee3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ed5f897553ea7ee3$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ed5f897553ea7ee3$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $ed5f897553ea7ee3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $39vnG.default)(this, AnalyticsEvent);
        (0, $9Ecwd.default)(this, "_isAnalyticsEvent", true);
        (0, $9Ecwd.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $ed5f897553ea7ee3$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $1atGc.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $47JGX.default)(updater) === "object") this.payload = $ed5f897553ea7ee3$var$_objectSpread($ed5f897553ea7ee3$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("22fiO", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $17b7a3685a9a4a81$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $17b7a3685a9a4a81$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("aBDec", function(module, exports) {

$parcel$export(module.exports, "AvatarContent", function () { return $7b8bc9f087c83efd$export$47fbc0b44cae5559; });

var $y8mkn = parcelRequire("y8mkn");

var $9Ecwd = parcelRequire("9Ecwd");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jxLBU = parcelRequire("jxLBU");

var $hgdFQ = parcelRequire("hgdFQ");

var $15D8Q = parcelRequire("15D8Q");
var $7b8bc9f087c83efd$var$boxShadowCssVar = "--avatar-box-shadow";
var $7b8bc9f087c83efd$var$bgColorCssVar = "--avatar-bg-color";
var $7b8bc9f087c83efd$var$styles = {
    root: (0, $2ZUkg.css)({
        display: "flex",
        boxSizing: "content-box",
        position: "static",
        alignItems: "stretch",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: "var(".concat($7b8bc9f087c83efd$var$bgColorCssVar, ")"),
        border: "none",
        boxShadow: "var(".concat($7b8bc9f087c83efd$var$boxShadowCssVar, ")"),
        cursor: "inherit",
        marginBlockEnd: "var(--ds-space-025, 2px)",
        marginBlockStart: "var(--ds-space-025, 2px)",
        marginInlineEnd: "var(--ds-space-025, 2px)",
        marginInlineStart: "var(--ds-space-025, 2px)",
        outline: "none",
        overflow: "hidden",
        paddingBlockEnd: "var(--ds-space-0, 0px)",
        paddingBlockStart: "var(--ds-space-0, 0px)",
        paddingInlineEnd: "var(--ds-space-0, 0px)",
        paddingInlineStart: "var(--ds-space-0, 0px)",
        transform: "translateZ(0)",
        transition: "transform 200ms, opacity 200ms",
        "&::after": {
            width: "100%",
            position: "absolute",
            inset: "var(--ds-space-0, 0px)",
            backgroundColor: "transparent",
            content: "' '",
            opacity: 0,
            pointerEvents: "none",
            transition: "opacity 200ms"
        },
        "&:focus-visible": {
            boxShadow: "none",
            outlineColor: "var(--ds-border-focused, #2684FF)",
            outlineOffset: "var(--ds-border-width-outline, 2px)",
            outlineStyle: "solid",
            outlineWidth: "var(--ds-border-width-outline, 2px)"
        },
        "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
            "&:focus-visible": {
                outlineWidth: "var(--ds-border-width, 1px)"
            }
        }
    }),
    circle: (0, $2ZUkg.css)({
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        "&::after": {
            borderRadius: "var(--ds-border-radius-circle, 50%)"
        }
    }),
    positionRelative: (0, $2ZUkg.css)({
        position: "relative"
    }),
    interactive: (0, $2ZUkg.css)({
        cursor: "pointer",
        "&:hover": {
            "&::after": {
                backgroundColor: "var(--ds-interaction-hovered, ".concat((0, $hgdFQ.N70A), ")"),
                opacity: 1
            }
        },
        "&:active": {
            transform: "scale(0.9)",
            "&::after": {
                backgroundColor: "var(--ds-interaction-pressed, ".concat((0, $hgdFQ.N70A), ")"),
                opacity: 1
            }
        },
        "@media screen and (forced-colors: active)": {
            "&:focus-visible": {
                outlineWidth: 1
            }
        }
    }),
    disabled: (0, $2ZUkg.css)({
        cursor: "not-allowed",
        "&::after": {
            backgroundColor: "var(--ds-surface, ".concat((0, $hgdFQ.N0), ")"),
            opacity: "var(--ds-opacity-disabled, 0.7)"
        }
    })
};
var $7b8bc9f087c83efd$var$widthHeightMap = {
    xsmall: (0, $2ZUkg.css)({
        width: "16px",
        height: "16px"
    }),
    small: (0, $2ZUkg.css)({
        width: "24px",
        height: "24px"
    }),
    medium: (0, $2ZUkg.css)({
        width: "32px",
        height: "32px"
    }),
    large: (0, $2ZUkg.css)({
        width: "40px",
        height: "40px"
    }),
    xlarge: (0, $2ZUkg.css)({
        width: "96px",
        height: "96px"
    }),
    xxlarge: (0, $2ZUkg.css)({
        width: "128px",
        height: "128px"
    })
};
var $7b8bc9f087c83efd$var$borderRadiusMap = {
    xsmall: (0, $2ZUkg.css)({
        borderRadius: "2px",
        "&::after": {
            borderRadius: "2px"
        }
    }),
    small: (0, $2ZUkg.css)({
        borderRadius: "2px",
        "&::after": {
            borderRadius: "2px"
        }
    }),
    medium: (0, $2ZUkg.css)({
        borderRadius: "3px",
        "&::after": {
            borderRadius: "3px"
        }
    }),
    large: (0, $2ZUkg.css)({
        borderRadius: "3px",
        "&::after": {
            borderRadius: "3px"
        }
    }),
    xlarge: (0, $2ZUkg.css)({
        borderRadius: "6px",
        "&::after": {
            borderRadius: "6px"
        }
    }),
    xxlarge: (0, $2ZUkg.css)({
        borderRadius: "12px",
        "&::after": {
            borderRadius: "12px"
        }
    })
};
var $7b8bc9f087c83efd$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $15D8Q.useEnsureIsInsideAvatar)();
    var _useAvatarContent = (0, $15D8Q.useAvatarContent)(), Container = _useAvatarContent.as, appearance = _useAvatarContent.appearance, avatarImage = _useAvatarContent.avatarImage, _useAvatarContent$bor = _useAvatarContent.borderColor, borderColor = _useAvatarContent$bor === void 0 ? (0, $jxLBU.fg)("platform-component-visual-refresh") ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, ".concat((0, $hgdFQ.N0), ")") : _useAvatarContent$bor, href = _useAvatarContent.href, isDisabled = _useAvatarContent.isDisabled, label = _useAvatarContent.label, onClick = _useAvatarContent.onClick, contextRef = _useAvatarContent.ref, tabIndex = _useAvatarContent.tabIndex, target = _useAvatarContent.target, testId = _useAvatarContent.testId, size = _useAvatarContent.size, stackIndex = _useAvatarContent.stackIndex;
    var isInteractive = Boolean(onClick || href || isDisabled);
    return (0, $2ZUkg.jsx)(Container, (0, $y8mkn.default)({
        css: [
            $7b8bc9f087c83efd$var$styles.root,
            $7b8bc9f087c83efd$var$borderRadiusMap[size],
            appearance === "circle" && $7b8bc9f087c83efd$var$styles.circle,
            $7b8bc9f087c83efd$var$widthHeightMap[size],
            stackIndex !== undefined && $7b8bc9f087c83efd$var$styles.positionRelative,
            isInteractive && !isDisabled && $7b8bc9f087c83efd$var$styles.interactive,
            isDisabled && $7b8bc9f087c83efd$var$styles.disabled
        ],
        style: (0, $9Ecwd.default)((0, $9Ecwd.default)({}, $7b8bc9f087c83efd$var$bgColorCssVar, borderColor), $7b8bc9f087c83efd$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === "button" ? "button" : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === "_blank" ? "noopener noreferrer" : undefined
    }), children || avatarImage);
});

});
parcelRegister("hgdFQ", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $c90e89a560ef4862$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $c90e89a560ef4862$export$2010d0fb4295b346; });
$parcel$export(module.exports, "G300", function () { return $c90e89a560ef4862$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $c90e89a560ef4862$export$a49394138f7b8e85; });
$parcel$export(module.exports, "B200", function () { return $c90e89a560ef4862$export$215b7063051591f1; });
$parcel$export(module.exports, "P300", function () { return $c90e89a560ef4862$export$b48405b95304b5a1; });
$parcel$export(module.exports, "N0", function () { return $c90e89a560ef4862$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $c90e89a560ef4862$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $c90e89a560ef4862$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $c90e89a560ef4862$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N90", function () { return $c90e89a560ef4862$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $c90e89a560ef4862$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $c90e89a560ef4862$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N500", function () { return $c90e89a560ef4862$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N800", function () { return $c90e89a560ef4862$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $c90e89a560ef4862$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $c90e89a560ef4862$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $c90e89a560ef4862$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $c90e89a560ef4862$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "N70A", function () { return $c90e89a560ef4862$export$6e5e7499ff054f6d; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $c90e89a560ef4862$export$4b84fd0e2c617bd = "#FFEBE6";
var $c90e89a560ef4862$export$b34b069eff244586 = "#FFBDAD";
var $c90e89a560ef4862$export$be802dd0d8b57f35 = "#FF8F73";
var $c90e89a560ef4862$export$60847d42f9da92a6 = "#FF7452";
var $c90e89a560ef4862$export$4a7404f376229999 = "#FF5630";
var $c90e89a560ef4862$export$2010d0fb4295b346 = "#DE350B";
var $c90e89a560ef4862$export$2837b5a1a71d5c02 = "#BF2600";
var $c90e89a560ef4862$export$8d9596b529bbb9cf = "#FFFAE6";
var $c90e89a560ef4862$export$41060a744ab0b7ae = "#FFF0B3";
var $c90e89a560ef4862$export$1cc05bbbf340e559 = "#FFE380";
var $c90e89a560ef4862$export$5aae31392d72caaa = "#FFC400";
var $c90e89a560ef4862$export$c6930421db9fa514 = "#FFAB00";
var $c90e89a560ef4862$export$59619663aa6500fb = "#FF991F";
var $c90e89a560ef4862$export$874739ea9e379ab6 = "#FF8B00";
var $c90e89a560ef4862$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $c90e89a560ef4862$export$69a3bf21b9686c2b = "#ABF5D1";
var $c90e89a560ef4862$export$afbce1382ec95f73 = "#79F2C0";
var $c90e89a560ef4862$export$747d86715d4175de = "#57D9A3";
var $c90e89a560ef4862$export$940e1f69e873f202 = "#36B37E";
var $c90e89a560ef4862$export$a49394138f7b8e85 = "#00875A";
var $c90e89a560ef4862$export$6fa04827ac68a4fb = "#006644";
var $c90e89a560ef4862$export$226de0355ed012f8 = "#DEEBFF";
var $c90e89a560ef4862$export$8c13c2ee36917869 = "#B3D4FF";
var $c90e89a560ef4862$export$ecfc1dff386a3e7a = "#4C9AFF";
var $c90e89a560ef4862$export$215b7063051591f1 = "#2684FF";
var $c90e89a560ef4862$export$e62e8919cca44969 = "#0065FF";
var $c90e89a560ef4862$export$b3de0ae08da2ce64 = "#0052CC";
var $c90e89a560ef4862$export$a6ee3d71bc067634 = "#0747A6";
var $c90e89a560ef4862$export$67f15409e87642a1 = "#669DF1";
var $c90e89a560ef4862$export$f0539dbc42dbb067 = "#8FB8F6";
var $c90e89a560ef4862$export$363e4475840015bb = "#EAE6FF";
var $c90e89a560ef4862$export$4b0a4417ed59760f = "#C0B6F2";
var $c90e89a560ef4862$export$6011520a64d9a187 = "#998DD9";
var $c90e89a560ef4862$export$a7175d4e9206bc80 = "#8777D9";
var $c90e89a560ef4862$export$b48405b95304b5a1 = "#6554C0";
var $c90e89a560ef4862$export$c71e4279dd54a18d = "#5243AA";
var $c90e89a560ef4862$export$147899de772240ec = "#403294";
var $c90e89a560ef4862$export$2cf711fe14c66f06 = "#E6FCFF";
var $c90e89a560ef4862$export$7a8f4d33f6f9772c = "#B3F5FF";
var $c90e89a560ef4862$export$776c9c497ef08533 = "#79E2F2";
var $c90e89a560ef4862$export$69cb3ca10c1e330e = "#00C7E6";
var $c90e89a560ef4862$export$9dc1ef0f3f48059b = "#00B8D9";
var $c90e89a560ef4862$export$7c835c78b6fcdef8 = "#00A3BF";
var $c90e89a560ef4862$export$6036577f95c3877e = "#008DA6";
var $c90e89a560ef4862$export$29a4f05edc054374 = "#FFFFFF";
var $c90e89a560ef4862$export$e655ef011c4aa1a2 = "#FAFBFC";
var $c90e89a560ef4862$export$9fdfb749e33cdf97 = "#F4F5F7";
var $c90e89a560ef4862$export$3e51e8f1440314ba = "#EBECF0";
var $c90e89a560ef4862$export$1ce2d1575d444ceb = "#DFE1E6";
var $c90e89a560ef4862$export$8754fc7e6d8b3000 = "#C1C7D0";
var $c90e89a560ef4862$export$c2e91cbeada39b8b = "#B3BAC5";
var $c90e89a560ef4862$export$5f71e19f3a7ad9de = "#A5ADBA";
var $c90e89a560ef4862$export$eaa8c8a70ac22806 = "#97A0AF";
var $c90e89a560ef4862$export$7c87d337fb91a97d = "#8993A4";
var $c90e89a560ef4862$export$d6447c357493214f = "#7A869A";
var $c90e89a560ef4862$export$f563ee71e9ee74cd = "#6B778C";
var $c90e89a560ef4862$export$e2ef2124cf4024b1 = "#5E6C84";
var $c90e89a560ef4862$export$eece5f492e429f08 = "#505F79";
var $c90e89a560ef4862$export$c39c0fe0f26207ae = "#42526E";
var $c90e89a560ef4862$export$7090862dc3038a9f = "#344563";
var $c90e89a560ef4862$export$ad0bacf983b7ddaa = "#253858";
var $c90e89a560ef4862$export$7d61b15e0da132af = "#172B4D";
var $c90e89a560ef4862$export$fbda843f0a27fe96 = "#091E42";
var $c90e89a560ef4862$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $c90e89a560ef4862$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $c90e89a560ef4862$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $c90e89a560ef4862$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $c90e89a560ef4862$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $c90e89a560ef4862$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $c90e89a560ef4862$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $c90e89a560ef4862$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $c90e89a560ef4862$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $c90e89a560ef4862$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $c90e89a560ef4862$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $c90e89a560ef4862$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $c90e89a560ef4862$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $c90e89a560ef4862$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $c90e89a560ef4862$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $c90e89a560ef4862$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $c90e89a560ef4862$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $c90e89a560ef4862$export$2f6319cf7d736c2a = "#E6EDFA";
var $c90e89a560ef4862$export$95126bc8884d6634 = "#DCE5F5";
var $c90e89a560ef4862$export$8338d8c35d44ff1 = "#CED9EB";
var $c90e89a560ef4862$export$5368d76ae4fbbda7 = "#B8C7E0";
var $c90e89a560ef4862$export$9f0a771d16ec8d36 = "#ABBBD6";
var $c90e89a560ef4862$export$abcf8c38338b4aa5 = "#9FB0CC";
var $c90e89a560ef4862$export$97e81faa16a182c7 = "#8C9CB8";
var $c90e89a560ef4862$export$bfe21c59123ecf33 = "#7988A3";
var $c90e89a560ef4862$export$ee82aa2ea6a1558 = "#67758F";
var $c90e89a560ef4862$export$682927c6ed76be02 = "#56637A";
var $c90e89a560ef4862$export$91fd9994c5be9757 = "#455166";
var $c90e89a560ef4862$export$d281fbfe3cff2df6 = "#3B475C";
var $c90e89a560ef4862$export$3902c91d8b98a753 = "#313D52";
var $c90e89a560ef4862$export$8e8133c1ba5845b5 = "#283447";
var $c90e89a560ef4862$export$33ff357f6620b39 = "#202B3D";
var $c90e89a560ef4862$export$633847cf062b69e0 = "#1B2638";
var $c90e89a560ef4862$export$9776a6e503bdbf76 = "#121A29";
var $c90e89a560ef4862$export$6c813d5160dff5db = "#0E1624";
var $c90e89a560ef4862$export$3d4f271a500072a = "#0D1424";
var $c90e89a560ef4862$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $c90e89a560ef4862$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $c90e89a560ef4862$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $c90e89a560ef4862$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $c90e89a560ef4862$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $c90e89a560ef4862$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $c90e89a560ef4862$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $c90e89a560ef4862$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $c90e89a560ef4862$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $c90e89a560ef4862$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $c90e89a560ef4862$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $c90e89a560ef4862$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $c90e89a560ef4862$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $c90e89a560ef4862$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $c90e89a560ef4862$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $c90e89a560ef4862$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $c90e89a560ef4862$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $c90e89a560ef4862$export$d2adc5dedf09fced = "#292A2E";
var $c90e89a560ef4862$export$f51762073d2bb381 = "#94C748";
var $c90e89a560ef4862$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("15D8Q", function(module, exports) {

$parcel$export(module.exports, "useAvatarContext", function () { return $0cb49ec91fa337cf$export$b50b87a1c4086b23; });
$parcel$export(module.exports, "AvatarContentContext", function () { return $0cb49ec91fa337cf$export$b983474ddd0b6d28; });
$parcel$export(module.exports, "useAvatarContent", function () { return $0cb49ec91fa337cf$export$79d078b69b7e4842; });
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", function () { return $0cb49ec91fa337cf$export$6b4cbd90d24955ad; });
$parcel$export(module.exports, "useEnsureIsInsideAvatar", function () { return $0cb49ec91fa337cf$export$7db5c57474082dd9; });

var $iSvIT = parcelRequire("iSvIT");
var $0cb49ec91fa337cf$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $0cb49ec91fa337cf$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $iSvIT.useContext)($0cb49ec91fa337cf$export$a20dad690e1279e2);
};
var $0cb49ec91fa337cf$var$defaultAvatarContentProps = {
    as: "span",
    appearance: "circle",
    avatarImage: null,
    ref: null,
    size: "medium"
};
var $0cb49ec91fa337cf$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $iSvIT.createContext)($0cb49ec91fa337cf$var$defaultAvatarContentProps);
var $0cb49ec91fa337cf$export$79d078b69b7e4842 = function useAvatarContent() {
    return (0, $iSvIT.useContext)($0cb49ec91fa337cf$export$b983474ddd0b6d28);
};
var $0cb49ec91fa337cf$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $0cb49ec91fa337cf$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $iSvIT.useContext)($0cb49ec91fa337cf$export$6b4cbd90d24955ad);
    if (!context) throw new Error("Avatar sub-components must be used within a Avatar component.");
};

});


parcelRegister("eMgAN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac226b48de0510a4$export$2e2bcd8739ae039; });

var $9Ecwd = parcelRequire("9Ecwd");

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $6f9l1 = parcelRequire("6f9l1");

var $6y0qC = parcelRequire("6y0qC");

var $7NvwX = parcelRequire("7NvwX");

var $dznp4 = parcelRequire("dznp4");

var $jxLBU = parcelRequire("jxLBU");

var $hgdFQ = parcelRequire("hgdFQ");

var $1NXQZ = parcelRequire("1NXQZ");
function $ac226b48de0510a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ac226b48de0510a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ac226b48de0510a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ac226b48de0510a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ac226b48de0510a4$var$avatarDefaultIconStyles = (0, $2ZUkg.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    backgroundColor: "var(--ds-icon-subtle, ".concat((0, $hgdFQ.N90), ")")
});
var $ac226b48de0510a4$var$avatarDefaultIconVisualRefreshStyles = (0, $2ZUkg.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
});
var $ac226b48de0510a4$var$nestedAvatarStyles = Object.entries((0, $1NXQZ.AVATAR_SIZES)).reduce(function(styles, _ref) {
    var _ref2 = (0, $glJen.default)(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $ac226b48de0510a4$var$_objectSpread($ac226b48de0510a4$var$_objectSpread({}, styles), {}, (0, $9Ecwd.default)({}, key, (0, $2ZUkg.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& svg": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: "".concat(size, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: "".concat(size, "px")
        }
    })));
}, {});
var $ac226b48de0510a4$var$avatarImageStyles = (0, $2ZUkg.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    flex: "1 1 100%"
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $ac226b48de0510a4$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? "" : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $glJen.default)(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === "circle" ? "50%" : "".concat((0, $1NXQZ.AVATAR_RADIUS)[size], "px");
    var isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $iSvIT.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $2ZUkg.jsx)("span", {
        css: [
            (0, $jxLBU.fg)("platform-component-visual-refresh") ? $ac226b48de0510a4$var$avatarDefaultIconVisualRefreshStyles : $ac226b48de0510a4$var$avatarDefaultIconStyles,
            $ac226b48de0510a4$var$nestedAvatarStyles[size]
        ]
    }, appearance === "circle" ? (0, $jxLBU.fg)("platform-component-visual-refresh") ? (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7NvwX))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6f9l1))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $hgdFQ.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $hgdFQ.N90), ")"),
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $jxLBU.fg)("platform-component-visual-refresh") ? (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dznp4))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }) : (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6y0qC))), {
        label: alt,
        color: "var(--ds-icon-inverse, ".concat((0, $hgdFQ.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-icon-subtle, ".concat((0, $hgdFQ.N90), ")"),
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }));
    return (0, $2ZUkg.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $ac226b48de0510a4$var$avatarImageStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": isHidden,
        "data-vc": testId ? "".concat(testId, "--image") : "avatar-image",
        "data-ssr-placeholder-ignored": true
    });
};
var $ac226b48de0510a4$export$2e2bcd8739ae039 = $ac226b48de0510a4$var$AvatarImage;

});
parcelRegister("6f9l1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::67744cfb74ed451c0181f18c132cbdd7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48bb6321ccb1b7a8$var$_react = $48bb6321ccb1b7a8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $48bb6321ccb1b7a8$var$_person = $48bb6321ccb1b7a8$var$_interopRequireDefault((parcelRequire("7NvwX")));

var $48bb6321ccb1b7a8$var$_person2 = $48bb6321ccb1b7a8$var$_interopRequireDefault((parcelRequire("9PdMG")));
function $48bb6321ccb1b7a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48bb6321ccb1b7a8$var$PersonIcon = (props)=>/*#__PURE__*/ $48bb6321ccb1b7a8$var$_react.default.createElement($48bb6321ccb1b7a8$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $48bb6321ccb1b7a8$var$_person2.default
    }, props));
$48bb6321ccb1b7a8$var$PersonIcon.Name = "PersonIconMigration";
var $48bb6321ccb1b7a8$var$_default = module.exports.default = $48bb6321ccb1b7a8$var$PersonIcon;

});
parcelRegister("7NvwX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7f51491040268dbfa9258c45e59f2b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ad5914c61a82d2f$var$_react = $5ad5914c61a82d2f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5ad5914c61a82d2f$var$_baseNew = $5ad5914c61a82d2f$var$_interopRequireDefault((parcelRequire("7Cb51")));
function $5ad5914c61a82d2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ad5914c61a82d2f$var$PersonIcon = (props)=>/*#__PURE__*/ $5ad5914c61a82d2f$var$_react.default.createElement($5ad5914c61a82d2f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$5ad5914c61a82d2f$var$PersonIcon.displayName = "PersonIcon";
var $5ad5914c61a82d2f$var$_default = module.exports.default = $5ad5914c61a82d2f$var$PersonIcon;

});
parcelRegister("7Cb51", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("lIRLX")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("lIRLX")).Icon; });

var $lIRLX = parcelRequire("lIRLX");

});
parcelRegister("lIRLX", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $fd076b1ef801bfc5$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $fd076b1ef801bfc5$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jxLBU = parcelRequire("jxLBU");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $fd076b1ef801bfc5$var$commonSVGStyles = (0, $2ZUkg.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $fd076b1ef801bfc5$var$svgStyles = (0, $2ZUkg.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $fd076b1ef801bfc5$var$iconStyles = (0, $2ZUkg.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $fd076b1ef801bfc5$var$utilityIconStyles = (0, $2ZUkg.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $fd076b1ef801bfc5$var$scaleStyles = (0, $2ZUkg.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $fd076b1ef801bfc5$var$baseHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $fd076b1ef801bfc5$var$scaleSize = (0, $2ZUkg.css)({
    width: "inherit",
    height: "inherit"
});
var $fd076b1ef801bfc5$var$sizeMap = {
    core: {
        none: (0, $2ZUkg.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $2ZUkg.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $2ZUkg.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $2ZUkg.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $2ZUkg.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $fd076b1ef801bfc5$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $fd076b1ef801bfc5$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $fd076b1ef801bfc5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $2ZUkg.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $fd076b1ef801bfc5$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $fd076b1ef801bfc5$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $fd076b1ef801bfc5$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $2ZUkg.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $fd076b1ef801bfc5$var$iconStyles,
            $fd076b1ef801bfc5$var$baseHcmStyles,
            shouldScale && $fd076b1ef801bfc5$var$scaleStyles,
            props.type === "utility" && $fd076b1ef801bfc5$var$utilityIconStyles
        ]
    }, (0, $2ZUkg.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $fd076b1ef801bfc5$var$commonSVGStyles,
            $fd076b1ef801bfc5$var$svgStyles,
            shouldScale ? $fd076b1ef801bfc5$var$scaleSize : props.type === "utility" ? $fd076b1ef801bfc5$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $fd076b1ef801bfc5$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $fd076b1ef801bfc5$export$2e2bcd8739ae039 = $fd076b1ef801bfc5$export$f04a61298a47a40f;

});



parcelRegister("9PdMG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $727391c174b030d1$var$_react = $727391c174b030d1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $kWUwC = parcelRequire("kWUwC");

var $727391c174b030d1$var$_person = $727391c174b030d1$var$_interopRequireDefault((parcelRequire("7NvwX")));
function $727391c174b030d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $727391c174b030d1$var$PersonIcon = (props)=>/*#__PURE__*/ $727391c174b030d1$var$_react.default.createElement($kWUwC.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $727391c174b030d1$var$_person.default
    }));
$727391c174b030d1$var$PersonIcon.displayName = "PersonIcon";
var $727391c174b030d1$var$_default = module.exports.default = $727391c174b030d1$var$PersonIcon;

});
parcelRegister("kWUwC", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $f4051224cb001c43$export$3cfb73f70dfca966; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $d4MNC = parcelRequire("d4MNC");
var $f4051224cb001c43$var$_excluded = [
    "dangerouslySetGlyph"
];
var $f4051224cb001c43$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $f4051224cb001c43$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $iSvIT.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, $Zqzri.default)(_ref, $f4051224cb001c43$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $jxLBU.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Icon, (0, $y8mkn.default)({}, props, {
                spacing: (0, $jxLBU.fg)("platform-visual-refresh-icons-facade-button-fix") ? $f4051224cb001c43$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(_Icon, (0, $y8mkn.default)({}, props, {
                spacing: $f4051224cb001c43$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $d4MNC.Icon), (0, $y8mkn.default)({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("d4MNC", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $9851809de325aec8$export$f04a61298a47a40f; });

var $y8mkn = parcelRequire("y8mkn");

var $9Ecwd = parcelRequire("9Ecwd");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $iPdwI = parcelRequire("iPdwI");

var $ljP7f = parcelRequire("ljP7f");
function $9851809de325aec8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9851809de325aec8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9851809de325aec8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9851809de325aec8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $9851809de325aec8$var$iconStyles = (0, $2ZUkg.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $9851809de325aec8$var$_objectSpread($9851809de325aec8$var$_objectSpread({}, (0, $iPdwI.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $9851809de325aec8$var$baseHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $9851809de325aec8$var$primaryEqualsSecondaryHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $9851809de325aec8$var$secondaryTransparentHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $9851809de325aec8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $2ZUkg.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $iPdwI.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $2ZUkg.jsx)("span", (0, $y8mkn.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $ljP7f.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $9851809de325aec8$var$iconStyles,
            $9851809de325aec8$var$baseHcmStyles,
            primaryColor === secondaryColor && $9851809de325aec8$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $9851809de325aec8$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $2ZUkg.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $9851809de325aec8$export$2e2bcd8739ae039 = $9851809de325aec8$export$f04a61298a47a40f;

});
parcelRegister("iPdwI", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $db477b87fcf464b1$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $db477b87fcf464b1$export$3eb7d6130acfda37; });

var $lFJPX = parcelRequire("lFJPX");

var $2ZUkg = parcelRequire("2ZUkg");
var $db477b87fcf464b1$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $db477b87fcf464b1$var$smallStyles = (0, $2ZUkg.css)((0, $lFJPX.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $db477b87fcf464b1$var$mediumStyles = (0, $2ZUkg.css)((0, $lFJPX.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $db477b87fcf464b1$var$largeStyles = (0, $2ZUkg.css)((0, $lFJPX.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $db477b87fcf464b1$var$xlargeStyles = (0, $2ZUkg.css)((0, $lFJPX.dimensions).xlarge);
var $db477b87fcf464b1$export$ef0ad74202575b64 = {
    small: $db477b87fcf464b1$var$smallStyles,
    medium: $db477b87fcf464b1$var$mediumStyles,
    large: $db477b87fcf464b1$var$largeStyles,
    xlarge: $db477b87fcf464b1$var$xlargeStyles
};
var $db477b87fcf464b1$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $lFJPX.dimensions)[size];
    return undefined;
};

});
parcelRegister("lFJPX", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $fc70fb901958c28f$export$62ad7b0c781000e9; });
var $fc70fb901958c28f$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $fc70fb901958c28f$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $fc70fb901958c28f$export$62ad7b0c781000e9 = {
    small: {
        width: $fc70fb901958c28f$export$c647cb0ee6e282fe.small,
        height: $fc70fb901958c28f$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $fc70fb901958c28f$export$c647cb0ee6e282fe.medium,
        height: $fc70fb901958c28f$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $fc70fb901958c28f$export$c647cb0ee6e282fe.large,
        height: $fc70fb901958c28f$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $fc70fb901958c28f$export$c647cb0ee6e282fe.xlarge,
        height: $fc70fb901958c28f$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("ljP7f", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $f85305e4ba55a1cf$export$18cb9425622d4e06; });
var $f85305e4ba55a1cf$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});





parcelRegister("6y0qC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::553e71e438a60de37e6f93988cb1bfa5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c46401af6fa8588$var$_react = $4c46401af6fa8588$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $4c46401af6fa8588$var$_release = $4c46401af6fa8588$var$_interopRequireDefault((parcelRequire("dznp4")));

var $4c46401af6fa8588$var$_ship = $4c46401af6fa8588$var$_interopRequireDefault((parcelRequire("iAkAv")));
function $4c46401af6fa8588$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c46401af6fa8588$var$ReleaseIcon = (props)=>/*#__PURE__*/ $4c46401af6fa8588$var$_react.default.createElement($4c46401af6fa8588$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $4c46401af6fa8588$var$_ship.default
    }, props));
$4c46401af6fa8588$var$ReleaseIcon.Name = "ReleaseIconMigration";
var $4c46401af6fa8588$var$_default = module.exports.default = $4c46401af6fa8588$var$ReleaseIcon;

});
parcelRegister("dznp4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08061a6d953c7d73b57c2e6e0bdac389>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e10b2a940a8dcc2$var$_react = $9e10b2a940a8dcc2$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9e10b2a940a8dcc2$var$_baseNew = $9e10b2a940a8dcc2$var$_interopRequireDefault((parcelRequire("7Cb51")));
function $9e10b2a940a8dcc2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e10b2a940a8dcc2$var$ReleaseIcon = (props)=>/*#__PURE__*/ $9e10b2a940a8dcc2$var$_react.default.createElement($9e10b2a940a8dcc2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
    }, props));
$9e10b2a940a8dcc2$var$ReleaseIcon.displayName = "ReleaseIcon";
var $9e10b2a940a8dcc2$var$_default = module.exports.default = $9e10b2a940a8dcc2$var$ReleaseIcon;

});

parcelRegister("iAkAv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d87b8f141c0a4a4a$var$_react = $d87b8f141c0a4a4a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $kWUwC = parcelRequire("kWUwC");

var $d87b8f141c0a4a4a$var$_release = $d87b8f141c0a4a4a$var$_interopRequireDefault((parcelRequire("dznp4")));
function $d87b8f141c0a4a4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d87b8f141c0a4a4a$var$ShipIcon = (props)=>/*#__PURE__*/ $d87b8f141c0a4a4a$var$_react.default.createElement($kWUwC.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $d87b8f141c0a4a4a$var$_release.default
    }));
$d87b8f141c0a4a4a$var$ShipIcon.displayName = "ShipIcon";
var $d87b8f141c0a4a4a$var$_default = module.exports.default = $d87b8f141c0a4a4a$var$ShipIcon;

});


parcelRegister("1NXQZ", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", function () { return $1508cbc22138d25b$export$9a270941bcff7e77; });
$parcel$export(module.exports, "AVATAR_RADIUS", function () { return $1508cbc22138d25b$export$e6da6efe4d1a5c9b; });
$parcel$export(module.exports, "BORDER_WIDTH", function () { return $1508cbc22138d25b$export$e2bd4c1faded7921; });
$parcel$export(module.exports, "ICON_SIZES", function () { return $1508cbc22138d25b$export$fdc820179f1f9be4; });
$parcel$export(module.exports, "ICON_OFFSET", function () { return $1508cbc22138d25b$export$382610e783aa2ae8; });
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $1N6gx = parcelRequire("1N6gx");
var $1508cbc22138d25b$export$9a270941bcff7e77 = {
    xsmall: (0, $1N6gx.gridSize)() * 2,
    small: (0, $1N6gx.gridSize)() * 3,
    medium: (0, $1N6gx.gridSize)() * 4,
    large: (0, $1N6gx.gridSize)() * 5,
    xlarge: (0, $1N6gx.gridSize)() * 12,
    xxlarge: (0, $1N6gx.gridSize)() * 16
};
var $1508cbc22138d25b$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $1508cbc22138d25b$export$e2bd4c1faded7921 = 2;
var $1508cbc22138d25b$export$89a980dfdf90df51 = 0.9;
var $1508cbc22138d25b$export$3c061e31594ebabe = "--avatar-background-color";
var $1508cbc22138d25b$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $1508cbc22138d25b$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});
parcelRegister("1N6gx", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $14df3a504846801c$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $14df3a504846801c$export$7be255094ccdc533; });

var $KsdEf = parcelRequire("KsdEf");

var $hgdFQ = parcelRequire("hgdFQ");
var $14df3a504846801c$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $14df3a504846801c$export$c93026a968943f95 = "light";
var $14df3a504846801c$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $14df3a504846801c$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $14df3a504846801c$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $14df3a504846801c$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $hgdFQ.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $14df3a504846801c$export$6d8204c2cb2e06b8() / 4;
    (0, $KsdEf.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $14df3a504846801c$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $14df3a504846801c$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $14df3a504846801c$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $KsdEf.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $14df3a504846801c$export$ba1d834b86d72a09 = $14df3a504846801c$export$a1b3edb637fb4f35;
var $14df3a504846801c$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $hgdFQ.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $hgdFQ.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $hgdFQ.N30A), ")")
            }
        }
    };
};

});



parcelRegister("eNnAt", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", function () { return $ac57f036e5111560$export$972c5e90200fa0ef; });

var $iSvIT = parcelRequire("iSvIT");

var $hgdFQ = parcelRequire("hgdFQ");

var $1NXQZ = parcelRequire("1NXQZ");

var $bVJz4 = parcelRequire("bVJz4");
var $ac57f036e5111560$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $hgdFQ.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $hgdFQ.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $ac57f036e5111560$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $hgdFQ.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $ac57f036e5111560$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $hgdFQ.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $hgdFQ.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $ac57f036e5111560$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $hgdFQ.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $ac57f036e5111560$var$getPresence(presence) {
    switch(presence){
        case "busy":
            return $ac57f036e5111560$var$BusyIndicator;
        case "focus":
            return $ac57f036e5111560$var$FocusIndicator;
        case "offline":
            return $ac57f036e5111560$var$OfflineIndicator;
        case "online":
            return $ac57f036e5111560$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $ac57f036e5111560$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bVJz4.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $ac57f036e5111560$var$getPresence(presence)) : children);
};
var $ac57f036e5111560$export$2e2bcd8739ae039 = $ac57f036e5111560$var$AvatarPresence;
var $ac57f036e5111560$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === "square" ? -4 : (0, $1NXQZ.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: "none",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "absolute",
            bottom: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $1NXQZ.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $1NXQZ.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($ac57f036e5111560$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("bVJz4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8af85cbee44e70cf$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $2ZUkg = parcelRequire("2ZUkg");

var $hgdFQ = parcelRequire("hgdFQ");

var $1NXQZ = parcelRequire("1NXQZ");
var $8af85cbee44e70cf$var$iconWrapperStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    alignItems: "center",
    alignContent: "center",
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: "hidden"
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $8af85cbee44e70cf$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $hgdFQ.N0), ")") : _ref$bgColor, children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $8af85cbee44e70cf$var$iconWrapperStyles,
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            border: "".concat((0, $1NXQZ.BORDER_WIDTH), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $8af85cbee44e70cf$export$2e2bcd8739ae039 = $8af85cbee44e70cf$var$IconWrapper;

});


parcelRegister("4RZ47", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", function () { return $38bb7afcaad793ef$export$8045894f255f9726; });

var $iSvIT = parcelRequire("iSvIT");

var $hgdFQ = parcelRequire("hgdFQ");

var $1NXQZ = parcelRequire("1NXQZ");

var $bVJz4 = parcelRequire("bVJz4");
var $38bb7afcaad793ef$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $hgdFQ.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $hgdFQ.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $38bb7afcaad793ef$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $hgdFQ.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $hgdFQ.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $38bb7afcaad793ef$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $hgdFQ.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $hgdFQ.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $38bb7afcaad793ef$var$getStatus(status) {
    switch(status){
        case "approved":
            return $38bb7afcaad793ef$var$ApprovedIndicator;
        case "declined":
            return $38bb7afcaad793ef$var$DeclinedIndicator;
        case "locked":
            return $38bb7afcaad793ef$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $38bb7afcaad793ef$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $bVJz4.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $38bb7afcaad793ef$var$getStatus(status)) : children);
};
var $38bb7afcaad793ef$export$2e2bcd8739ae039 = $38bb7afcaad793ef$var$AvatarStatus;
var $38bb7afcaad793ef$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === "square" ? 0 : (0, $1NXQZ.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "absolute",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $1NXQZ.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $1NXQZ.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($38bb7afcaad793ef$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("9bEFI", function(module, exports) {

$parcel$export(module.exports, "getCustomElement", function () { return $6b04b0b2b4d25254$export$83ee468102cdf04c; });
var $6b04b0b2b4d25254$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === "_blank" ? "noopener noreferrer" : null,
        target: target
    };
};
var $6b04b0b2b4d25254$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: "button",
        onClick: onClick
    };
};
var $6b04b0b2b4d25254$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return "a";
    if (onClick || isDisabled) return "button";
    return "span";
};

});


parcelRegister("kXNP1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f42ff6f3af9d48ed$export$2e2bcd8739ae039; });

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");
function $f42ff6f3af9d48ed$export$2e2bcd8739ae039() {
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $glJen.default)(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $iSvIT.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $iSvIT.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("6Qn9B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fb98f44b66052cf$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $KsdEf = parcelRequire("KsdEf");

var $hgdFQ = parcelRequire("hgdFQ");

var $aPpua = parcelRequire("aPpua");
var $4fb98f44b66052cf$var$_excluded = [
    "children",
    "overrides",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $4fb98f44b66052cf$var$gridSize = 8;
var $4fb98f44b66052cf$var$itemHeadingTopMargin = $4fb98f44b66052cf$var$gridSize * 2.5;
var $4fb98f44b66052cf$var$itemHeadingBottomMargin = $4fb98f44b66052cf$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $4fb98f44b66052cf$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $4fb98f44b66052cf$var$skeletonHeadingHeight = $4fb98f44b66052cf$var$gridSize;
var $4fb98f44b66052cf$var$skeletonHeadingMarginOffset = 3;
var $4fb98f44b66052cf$var$skeletonHeadingTopMargin = $4fb98f44b66052cf$var$itemHeadingTopMargin + ($4fb98f44b66052cf$var$itemHeadingContentHeight - $4fb98f44b66052cf$var$skeletonHeadingHeight) - $4fb98f44b66052cf$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $4fb98f44b66052cf$var$skeletonHeadingBottomMargin = $4fb98f44b66052cf$var$itemHeadingBottomMargin + $4fb98f44b66052cf$var$skeletonHeadingMarginOffset;
var $4fb98f44b66052cf$var$sectionPaddingTopBottom = $4fb98f44b66052cf$var$gridSize * 0.75;
var $4fb98f44b66052cf$var$VAR_SEPARATOR_COLOR = "--ds-menu-seperator-color";
var $4fb98f44b66052cf$var$sectionStyles = (0, $2ZUkg.css)({
    "&::before, &::after": {
        display: "block",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $4fb98f44b66052cf$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $4fb98f44b66052cf$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $4fb98f44b66052cf$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $4fb98f44b66052cf$var$itemHeadingTopMargin - $4fb98f44b66052cf$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--skeleton-heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $4fb98f44b66052cf$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $4fb98f44b66052cf$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $4fb98f44b66052cf$var$skeletonHeadingTopMargin - $4fb98f44b66052cf$var$sectionPaddingTopBottom
        }
    },
    "&:focus": {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $4fb98f44b66052cf$var$scrollableStyles = (0, $2ZUkg.css)({
    flexShrink: 1,
    overflow: "auto"
});
var $4fb98f44b66052cf$var$unscrollableStyles = (0, $2ZUkg.css)({
    flexShrink: 0
});
var $4fb98f44b66052cf$var$thinSeparatorStyles = (0, $2ZUkg.css)({
    borderBlockStart: "1px solid var(".concat($4fb98f44b66052cf$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $hgdFQ.N30A), ")"), ")")
});
var $4fb98f44b66052cf$var$noSeparatorStyles = (0, $2ZUkg.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "[data-section] + &": {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $4fb98f44b66052cf$var$Section = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, $Zqzri.default)(_ref, $4fb98f44b66052cf$var$_excluded);
    (0, $KsdEf.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $2ZUkg.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $iSvIT.Children).map((0, $iSvIT.Children).toArray(children), function(child, index) {
        return (0, $2ZUkg.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: "none",
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, (0, $2ZUkg.jsx)((0, $aPpua.default), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, content);
    return (0, $2ZUkg.jsx)("div", (0, $y8mkn.default)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        css: [
            $4fb98f44b66052cf$var$sectionStyles,
            isScrollable ? $4fb98f44b66052cf$var$scrollableStyles : $4fb98f44b66052cf$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $4fb98f44b66052cf$var$thinSeparatorStyles : $4fb98f44b66052cf$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $4fb98f44b66052cf$export$2e2bcd8739ae039 = $4fb98f44b66052cf$var$Section;

});
parcelRegister("aPpua", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e226fb4ae39427f$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $KsdEf = parcelRequire("KsdEf");

var $4OZuI = parcelRequire("4OZuI");

var $hgdFQ = parcelRequire("hgdFQ");
var $7e226fb4ae39427f$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $7e226fb4ae39427f$var$headingStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtle, ".concat((0, $hgdFQ.N300), ")"),
    font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $7e226fb4ae39427f$var$HeadingItem = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $4OZuI.default) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, $Zqzri.default)(_ref, $7e226fb4ae39427f$var$_excluded);
    (0, $KsdEf.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $4OZuI.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var UNSAFE_overrides = (0, $2ZUkg.css)(cssFn(undefined));
    return (0, $2ZUkg.jsx)("div", (0, $y8mkn.default)({
        css: [
            $7e226fb4ae39427f$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: UNSAFE_className
    }, rest), children);
});
var $7e226fb4ae39427f$export$2e2bcd8739ae039 = $7e226fb4ae39427f$var$HeadingItem;

});


parcelRegister("5YuF5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $459a5719b9592a3b$export$2e2bcd8739ae039; });

var $11tmd = parcelRequire("11tmd");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$459a5719b9592a3b$export$2e2bcd8739ae039 = (0, $11tmd.Popup);

});
parcelRegister("11tmd", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $0beca8327caeeead$export$129a32eedafa97c5; });

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $dWwnB = parcelRequire("dWwnB");

var $dfEzc = parcelRequire("dfEzc");

var $fYyCi = parcelRequire("fYyCi");

var $jxLBU = parcelRequire("jxLBU");

var $5X460 = parcelRequire("5X460");
var $b2CZb = parcelRequire("b2CZb");

var $7g0z5 = parcelRequire("7g0z5");

var $cD1VU = parcelRequire("cD1VU");
var $h4hoY = parcelRequire("h4hoY");

var $1N6gx = parcelRequire("1N6gx");

var $hgQDG = parcelRequire("hgQDG");

var $1NlOT = parcelRequire("1NlOT");

var $d5ZeW = parcelRequire("d5ZeW");

var $1iE5l = parcelRequire("1iE5l");
var $0beca8327caeeead$var$defaultLayer = (0, $1N6gx.layers).layer();
var $0beca8327caeeead$var$wrapperStyles = (0, $h4hoY.xcss)({
    position: "relative"
});
var $0beca8327caeeead$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $0beca8327caeeead$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $glJen.default)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $d5ZeW.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $1iE5l.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $dWwnB.useId)();
    var _usePopupAppearance = (0, $1NlOT.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    (0, $fYyCi.useNotifyOpenLayerObserver)({
        isOpen: isOpen
    });
    var renderPopperWrapper = (0, $2ZUkg.jsx)((0, $dfEzc.Layering), {
        isDisabled: false
    }, (0, $2ZUkg.jsx)((0, $hgQDG.default), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? "absolute" : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = (0, $2ZUkg.jsx)((0, $5X460.Manager), null, (0, $2ZUkg.jsx)((0, $b2CZb.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $jxLBU.fg)("platform-design-system-popup-ref") ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            "aria-controls": isOpen ? id : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": role === "dialog" && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock") ? "dialog" : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $2ZUkg.jsx)((0, $7g0z5.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return (0, $2ZUkg.jsx)((0, $cD1VU.default), {
        xcss: $0beca8327caeeead$var$wrapperStyles
    }, popupContent);
    return popupContent;
});
var $0beca8327caeeead$export$2e2bcd8739ae039 = $0beca8327caeeead$export$129a32eedafa97c5;

});
parcelRegister("dfEzc", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $9a5c24c72bbe0670$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $9a5c24c72bbe0670$export$48b383b280e20440; });
$parcel$export(module.exports, "Layering", function () { return $9a5c24c72bbe0670$export$7c885f891c940977; });

var $iSvIT = parcelRequire("iSvIT");

var $4OZuI = parcelRequire("4OZuI");
var $9a5c24c72bbe0670$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
var $9a5c24c72bbe0670$export$48b383b280e20440 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $4OZuI.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $9a5c24c72bbe0670$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $iSvIT.useContext)($9a5c24c72bbe0670$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($9a5c24c72bbe0670$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $9a5c24c72bbe0670$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $iSvIT.useRef)(0);
    var value = (0, $iSvIT.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($9a5c24c72bbe0670$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $9a5c24c72bbe0670$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $iSvIT.useContext)($9a5c24c72bbe0670$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($9a5c24c72bbe0670$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($9a5c24c72bbe0670$var$LayeringProvider, null, content);
};

});

parcelRegister("fYyCi", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $ba174fc01b33bce1$export$469bb693f11edc7f; });

var $iSvIT = parcelRequire("iSvIT");

var $5yG1r = parcelRequire("5yG1r");
function $ba174fc01b33bce1$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $iSvIT.useContext)((0, $5yG1r.OpenLayerObserverContext));
    (0, $iSvIT.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}

});
parcelRegister("5yG1r", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $40c0b9772e150978$export$5fbf4d7fae6cdc00; });

var $iSvIT = parcelRequire("iSvIT");
var $40c0b9772e150978$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});


parcelRegister("b2CZb", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $809e1f5d1d16c321$export$e0be378c32fb70a7; });

var $iSvIT = parcelRequire("iSvIT");

var $cAgz7 = parcelRequire("cAgz7");

var $5X460 = parcelRequire("5X460");

var $cGW7B = parcelRequire("cGW7B");
function $809e1f5d1d16c321$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $iSvIT.useContext((0, $5X460.ManagerReferenceNodeSetterContext));
    var refHandler = $iSvIT.useCallback(function(node) {
        (0, $cGW7B.setRef)(innerRef, node);
        (0, $cGW7B.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $iSvIT.useEffect(function() {
        return function() {
            return (0, $cGW7B.setRef)(innerRef, null);
        };
    }, []);
    $iSvIT.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($cAgz7)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $cGW7B.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("7g0z5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $548a7730170dea8d$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $Zc4JD = parcelRequire("Zc4JD");

var $l4687 = parcelRequire("l4687");

var $a1Qxy = parcelRequire("a1Qxy");

var $9f4Za = parcelRequire("9f4Za");
function $548a7730170dea8d$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $a1Qxy.default)(mountStrategy);
    (0, $9f4Za.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $jxLBU.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $Zc4JD.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $l4687.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("Zc4JD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b7f10897d686453$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $8ak6J = parcelRequire("8ak6J");
function $0b7f10897d686453$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $iSvIT.useMemo)(function() {
        return (0, $8ak6J.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $8ak6J.appendPortalContainerIfNotAppended)(container);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            (0, $8ak6J.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $i5UxU.createPortal)(children, container);
}

});
parcelRegister("8ak6J", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $5f1edadde3107a31$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $5f1edadde3107a31$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $5f1edadde3107a31$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $5f1edadde3107a31$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $5f1edadde3107a31$export$95029ca7aca2989e; });

var $iva4t = parcelRequire("iva4t");
var $5f1edadde3107a31$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $iva4t.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $5f1edadde3107a31$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $5f1edadde3107a31$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $iva4t.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $iva4t.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $5f1edadde3107a31$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $5f1edadde3107a31$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $5f1edadde3107a31$var$getPortalParent().removeChild(container);
};
var $5f1edadde3107a31$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $5f1edadde3107a31$var$getPortalParent().appendChild(container);
};
var $5f1edadde3107a31$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $5f1edadde3107a31$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($5f1edadde3107a31$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $iva4t.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $5f1edadde3107a31$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($5f1edadde3107a31$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $iva4t.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $iva4t.portalParentClassName);
            parent.style.display = "flex";
            (_getBody2 = $5f1edadde3107a31$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("iva4t", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $d782ef25ad793a28$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $d782ef25ad793a28$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $d782ef25ad793a28$export$13f57c02915787b3; });
var $d782ef25ad793a28$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $d782ef25ad793a28$export$72f415121273627e = "body > .atlaskit-portal-container";
var $d782ef25ad793a28$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("l4687", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f55eb9f90e033d78$export$2e2bcd8739ae039; });

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $jxLBU = parcelRequire("jxLBU");

var $gIWkb = parcelRequire("gIWkb");

var $8ak6J = parcelRequire("8ak6J");
function $f55eb9f90e033d78$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $glJen.default)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $gIWkb.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $8ak6J.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $8ak6J.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * Conditionally wrap ALL portal children with Suspense behind a feature gate for safe rollout.
   *
   * This is here because in React 18 concurrent, if you suspend from _within_ a portal to a
   * suspense boundary _outside_ a portal, our portal gets in an infinite loop of re-rendering.
   */ var conditionallySuspendedChildren = (0, $jxLBU.fg)("platform_design_system_suspend_portal_children") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Suspense), {
        fallback: null
    }, children) : children;
    return atlaskitPortal ? /*#__PURE__*/ (0, $i5UxU.createPortal)(conditionallySuspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("gIWkb", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $c2cdff6f4191ffbd$export$700979bc83e7db82; });

var $iSvIT = parcelRequire("iSvIT");
var $c2cdff6f4191ffbd$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $iSvIT.useLayoutEffect) : (0, $iSvIT.useEffect);

});


parcelRegister("a1Qxy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74d2c0c55c87373e$export$2e2bcd8739ae039; });

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $gIWkb = parcelRequire("gIWkb");
var $74d2c0c55c87373e$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $glJen.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $gIWkb.useIsomorphicLayoutEffect) : (0, $iSvIT.useEffect);
    }), _useState4 = (0, $glJen.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $74d2c0c55c87373e$export$2e2bcd8739ae039 = $74d2c0c55c87373e$var$useIsSubsequentRender;

});

parcelRegister("9f4Za", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ba961cc0323dd20$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $aYcjC = parcelRequire("aYcjC");

var $ivLvO = parcelRequire("ivLvO");
var $6ba961cc0323dd20$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $iSvIT.useEffect)(function() {
        (0, $ivLvO.default)((0, $aYcjC.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $ivLvO.default)((0, $aYcjC.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $6ba961cc0323dd20$export$2e2bcd8739ae039 = $6ba961cc0323dd20$var$useFirePortalEvent;

});
parcelRegister("aYcjC", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $7fc90f8afb4c729e$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $7fc90f8afb4c729e$export$80816bd900e5bd00; });
var $7fc90f8afb4c729e$export$ed5835cc67e87f72 = "akPortalMount";
var $7fc90f8afb4c729e$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("ivLvO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d79ffa221a0ff36d$export$2e2bcd8739ae039; });
var $d79ffa221a0ff36d$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $d79ffa221a0ff36d$var$getLayerName = function getLayerName(zIndex) {
    return $d79ffa221a0ff36d$var$zIndexToName.hasOwnProperty(zIndex) ? $d79ffa221a0ff36d$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $d79ffa221a0ff36d$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $d79ffa221a0ff36d$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $d79ffa221a0ff36d$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $d79ffa221a0ff36d$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("cD1VU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $931aa067a6ff928a$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $c1ge1 = parcelRequire("c1ge1");

var $igww8 = parcelRequire("igww8");

var $h4hoY = parcelRequire("h4hoY");
var $931aa067a6ff928a$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $931aa067a6ff928a$var$_excluded2 = [
    "className"
];
var $931aa067a6ff928a$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $Zqzri.default)(_ref, $931aa067a6ff928a$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $Zqzri.default)(htmlAttributes, $931aa067a6ff928a$var$_excluded2);
    var resolvedStyles = (0, $h4hoY.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $2ZUkg.jsx)(Component, (0, $y8mkn.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $931aa067a6ff928a$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $igww8.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $igww8.isSurfaceColorToken)(backgroundColor) && (0, $igww8.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $igww8.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $igww8.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $igww8.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $igww8.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $igww8.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $igww8.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $igww8.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $2ZUkg.jsx)((0, $c1ge1.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $931aa067a6ff928a$export$2e2bcd8739ae039 = $931aa067a6ff928a$export$e71c4d32a2263218;
var $931aa067a6ff928a$var$baseStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("c1ge1", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $8c022a043a6049de$export$1ca2a26fecb070ae; });

var $iSvIT = parcelRequire("iSvIT");
var $8c022a043a6049de$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $8c022a043a6049de$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($8c022a043a6049de$export$1ca2a26fecb070ae);
};
$8c022a043a6049de$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});

parcelRegister("igww8", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $d4c2f1e6991ea75e$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $d4c2f1e6991ea75e$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $d4c2f1e6991ea75e$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $d4c2f1e6991ea75e$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $d4c2f1e6991ea75e$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $d4c2f1e6991ea75e$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $d4c2f1e6991ea75e$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $d4c2f1e6991ea75e$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $d4c2f1e6991ea75e$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $d4c2f1e6991ea75e$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $d4c2f1e6991ea75e$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $d4c2f1e6991ea75e$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $d4c2f1e6991ea75e$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $d4c2f1e6991ea75e$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $d4c2f1e6991ea75e$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $d4c2f1e6991ea75e$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $d4c2f1e6991ea75e$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $d4c2f1e6991ea75e$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $d4c2f1e6991ea75e$export$5e65a44e5b6ecadb; });

var $9Ecwd = parcelRequire("9Ecwd");

var $2ZUkg = parcelRequire("2ZUkg");

var $1rUYR = parcelRequire("1rUYR");
function $d4c2f1e6991ea75e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d4c2f1e6991ea75e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d4c2f1e6991ea75e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d4c2f1e6991ea75e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d4c2f1e6991ea75e$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $d4c2f1e6991ea75e$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $d4c2f1e6991ea75e$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $d4c2f1e6991ea75e$export$632685d741f3dbbf = $d4c2f1e6991ea75e$var$_objectSpread($d4c2f1e6991ea75e$var$_objectSpread({}, $d4c2f1e6991ea75e$export$958d0ae7f2977ae4), $d4c2f1e6991ea75e$export$d2dc61f58390201c);
var $d4c2f1e6991ea75e$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $d4c2f1e6991ea75e$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $d4c2f1e6991ea75e$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $d4c2f1e6991ea75e$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $d4c2f1e6991ea75e$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $d4c2f1e6991ea75e$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $d4c2f1e6991ea75e$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $d4c2f1e6991ea75e$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $d4c2f1e6991ea75e$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $d4c2f1e6991ea75e$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $d4c2f1e6991ea75e$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $d4c2f1e6991ea75e$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $d4c2f1e6991ea75e$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $d4c2f1e6991ea75e$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $d4c2f1e6991ea75e$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $d4c2f1e6991ea75e$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $d4c2f1e6991ea75e$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $9Ecwd.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $d4c2f1e6991ea75e$export$e615f061ca585a6c = $d4c2f1e6991ea75e$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7(spacingProperty, $d4c2f1e6991ea75e$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $d4c2f1e6991ea75e$export$bf46c3f9eeafc71f = $d4c2f1e6991ea75e$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7(spacingProperty, $d4c2f1e6991ea75e$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $d4c2f1e6991ea75e$export$e7af83bafe7f9e63 = $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7("backgroundColor", $d4c2f1e6991ea75e$export$d1d79bf68ac056bd);
var $d4c2f1e6991ea75e$export$3a1bcba60b23d7f0 = $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7("color", $d4c2f1e6991ea75e$export$8473307aa00d6ea1);
var $d4c2f1e6991ea75e$export$45f3f4fe16f9f7d5 = $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7("fontWeight", $d4c2f1e6991ea75e$export$303e322c6b1ed114);
var $d4c2f1e6991ea75e$export$68cc305da27dbaa4 = $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7("fontFamily", $d4c2f1e6991ea75e$export$3c7e9587132614b4);
var $d4c2f1e6991ea75e$export$128f10c238242f83 = $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7("font", $d4c2f1e6991ea75e$export$6ffa317d5e70375);
var $d4c2f1e6991ea75e$export$219d364c0da35ae4 = $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7("font", $d4c2f1e6991ea75e$export$236bfe3a33ef1292);
var $d4c2f1e6991ea75e$export$38845ca010b93505 = $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7("fontWeight", $d4c2f1e6991ea75e$export$855cfd311192d666);
var $d4c2f1e6991ea75e$export$ff257d957d48c421 = $d4c2f1e6991ea75e$export$ca0f9c2de39ffed7((0, $1rUYR.CURRENT_SURFACE_CSS_VAR), $d4c2f1e6991ea75e$export$41a358c9c2356760);
var $d4c2f1e6991ea75e$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $d4c2f1e6991ea75e$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("1rUYR", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $10e4833601a4236e$export$9d7b58831ae93caa; });
var $10e4833601a4236e$export$4ef52930e33717cd = "data-theme";
var $10e4833601a4236e$export$a00eac3f8684bcd0 = "data-color-mode";
var $10e4833601a4236e$export$2112803007239c61 = "data-contrast-mode";
var $10e4833601a4236e$export$352e418ed5b6193a = "data-custom-theme";
var $10e4833601a4236e$export$2faeed762aac6741 = "light";
var $10e4833601a4236e$export$6f0c6fb8c80fcc92 = "ds";
var $10e4833601a4236e$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $10e4833601a4236e$export$dddac1532e822863 = "--".concat($10e4833601a4236e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $10e4833601a4236e$export$9d7b58831ae93caa = "--".concat($10e4833601a4236e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("h4hoY", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $c6d04f01e6fc6d6e$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $c6d04f01e6fc6d6e$export$f6c783d06584602c; });

var $2eRSM = parcelRequire("2eRSM");

var $9Ecwd = parcelRequire("9Ecwd");

var $glJen = parcelRequire("glJen");

var $47JGX = parcelRequire("47JGX");

var $2ZUkg = parcelRequire("2ZUkg");

var $igww8 = parcelRequire("igww8");

var $XAEGR = parcelRequire("XAEGR");
function $c6d04f01e6fc6d6e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c6d04f01e6fc6d6e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c6d04f01e6fc6d6e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c6d04f01e6fc6d6e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c6d04f01e6fc6d6e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c6d04f01e6fc6d6e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c6d04f01e6fc6d6e$export$9a199fbafee0014e = {
    backgroundColor: (0, $igww8.backgroundColorMap),
    blockSize: (0, $igww8.dimensionMap),
    borderBlockColor: (0, $igww8.borderColorMap),
    borderBlockEndColor: (0, $igww8.borderColorMap),
    borderBlockEndWidth: (0, $igww8.borderWidthMap),
    borderBlockStartColor: (0, $igww8.borderColorMap),
    borderBlockStartWidth: (0, $igww8.borderWidthMap),
    borderBlockWidth: (0, $igww8.borderWidthMap),
    borderBottomColor: (0, $igww8.borderColorMap),
    borderBottomLeftRadius: (0, $igww8.borderRadiusMap),
    borderBottomRightRadius: (0, $igww8.borderRadiusMap),
    borderBottomWidth: (0, $igww8.borderWidthMap),
    borderColor: (0, $igww8.borderColorMap),
    borderEndEndRadius: (0, $igww8.borderRadiusMap),
    borderEndStartRadius: (0, $igww8.borderRadiusMap),
    borderInlineColor: (0, $igww8.borderColorMap),
    borderInlineEndColor: (0, $igww8.borderColorMap),
    borderInlineEndWidth: (0, $igww8.borderWidthMap),
    borderInlineStartColor: (0, $igww8.borderColorMap),
    borderInlineStartWidth: (0, $igww8.borderWidthMap),
    borderInlineWidth: (0, $igww8.borderWidthMap),
    borderLeftColor: (0, $igww8.borderColorMap),
    borderLeftWidth: (0, $igww8.borderWidthMap),
    borderRadius: (0, $igww8.borderRadiusMap),
    borderRightColor: (0, $igww8.borderColorMap),
    borderRightWidth: (0, $igww8.borderWidthMap),
    borderStartEndRadius: (0, $igww8.borderRadiusMap),
    borderStartStartRadius: (0, $igww8.borderRadiusMap),
    borderTopColor: (0, $igww8.borderColorMap),
    borderTopLeftRadius: (0, $igww8.borderRadiusMap),
    borderTopRightRadius: (0, $igww8.borderRadiusMap),
    borderTopWidth: (0, $igww8.borderWidthMap),
    borderWidth: (0, $igww8.borderWidthMap),
    bottom: (0, $igww8.allSpaceMap),
    boxShadow: (0, $igww8.shadowMap),
    color: (0, $igww8.textColorMap),
    columnGap: (0, $igww8.positiveSpaceMap),
    font: (0, $igww8.fontMap),
    fontFamily: (0, $igww8.fontFamilyMap),
    fontWeight: (0, $igww8.fontWeightMap),
    gap: (0, $igww8.positiveSpaceMap),
    height: (0, $igww8.dimensionMap),
    inlineSize: (0, $igww8.dimensionMap),
    inset: (0, $igww8.allSpaceMap),
    insetBlock: (0, $igww8.allSpaceMap),
    insetBlockEnd: (0, $igww8.allSpaceMap),
    insetBlockStart: (0, $igww8.allSpaceMap),
    insetInline: (0, $igww8.allSpaceMap),
    insetInlineEnd: (0, $igww8.allSpaceMap),
    insetInlineStart: (0, $igww8.allSpaceMap),
    left: (0, $igww8.allSpaceMap),
    margin: (0, $igww8.allSpaceMap),
    marginBlock: (0, $igww8.allSpaceMap),
    marginBlockEnd: (0, $igww8.allSpaceMap),
    marginBlockStart: (0, $igww8.allSpaceMap),
    marginBottom: (0, $igww8.allSpaceMap),
    marginInline: (0, $igww8.allSpaceMap),
    marginInlineEnd: (0, $igww8.allSpaceMap),
    marginInlineStart: (0, $igww8.allSpaceMap),
    marginLeft: (0, $igww8.allSpaceMap),
    marginRight: (0, $igww8.allSpaceMap),
    marginTop: (0, $igww8.allSpaceMap),
    maxBlockSize: (0, $igww8.dimensionMap),
    maxHeight: (0, $igww8.dimensionMap),
    maxInlineSize: (0, $igww8.dimensionMap),
    maxWidth: (0, $igww8.dimensionMap),
    minBlockSize: (0, $igww8.dimensionMap),
    minHeight: (0, $igww8.dimensionMap),
    minInlineSize: (0, $igww8.dimensionMap),
    minWidth: (0, $igww8.dimensionMap),
    opacity: (0, $igww8.opacityMap),
    outlineColor: (0, $igww8.borderColorMap),
    outlineOffset: (0, $igww8.positiveSpaceMap),
    outlineWidth: (0, $igww8.borderWidthMap),
    padding: (0, $igww8.positiveSpaceMap),
    paddingBlock: (0, $igww8.positiveSpaceMap),
    paddingBlockEnd: (0, $igww8.positiveSpaceMap),
    paddingBlockStart: (0, $igww8.positiveSpaceMap),
    paddingBottom: (0, $igww8.positiveSpaceMap),
    paddingInline: (0, $igww8.positiveSpaceMap),
    paddingInlineEnd: (0, $igww8.positiveSpaceMap),
    paddingInlineStart: (0, $igww8.positiveSpaceMap),
    paddingLeft: (0, $igww8.positiveSpaceMap),
    paddingRight: (0, $igww8.positiveSpaceMap),
    paddingTop: (0, $igww8.positiveSpaceMap),
    right: (0, $igww8.allSpaceMap),
    rowGap: (0, $igww8.positiveSpaceMap),
    top: (0, $igww8.allSpaceMap),
    width: (0, $igww8.dimensionMap),
    zIndex: (0, $igww8.layerMap)
};
var $c6d04f01e6fc6d6e$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $c6d04f01e6fc6d6e$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $XAEGR === "undefined" ? "undefined" : (0, $47JGX.default)($XAEGR)) === "object" && (0, $47JGX.default)($XAEGR.env) === "object" && false;
};
var $c6d04f01e6fc6d6e$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $c6d04f01e6fc6d6e$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $c6d04f01e6fc6d6e$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $47JGX.default)(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($c6d04f01e6fc6d6e$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $glJen.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $47JGX.default)(value) === "object" && $c6d04f01e6fc6d6e$var$safeSelectors.test(key)) {
            styleObj[key] = $c6d04f01e6fc6d6e$var$_transformStyles(value);
            return;
        }
        if ($c6d04f01e6fc6d6e$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($c6d04f01e6fc6d6e$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $c6d04f01e6fc6d6e$export$9a199fbafee0014e)) return;
        var tokenValue = $c6d04f01e6fc6d6e$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $c6d04f01e6fc6d6e$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $c6d04f01e6fc6d6e$var$_transformStyles(style);
    return (0, $9Ecwd.default)({}, $c6d04f01e6fc6d6e$var$uniqueSymbol, (0, $2ZUkg.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $c6d04f01e6fc6d6e$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $c6d04f01e6fc6d6e$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $c6d04f01e6fc6d6e$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $2eRSM.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$c6d04f01e6fc6d6e$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $c6d04f01e6fc6d6e$export$f6c783d06584602c(style) {
    return $c6d04f01e6fc6d6e$var$baseXcss(style);
}

});


parcelRegister("hgQDG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c92cc355bead10fe$export$2e2bcd8739ae039; });

var $2eRSM = parcelRequire("2eRSM");

var $glJen = parcelRequire("glJen");

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $9Ecwd = parcelRequire("9Ecwd");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $7TCqn = parcelRequire("7TCqn");

var $jIxbv = parcelRequire("jIxbv");

var $jxLBU = parcelRequire("jxLBU");

var $gr749 = parcelRequire("gr749");

var $hgdFQ = parcelRequire("hgdFQ");

var $1N6gx = parcelRequire("1N6gx");

var $1rUYR = parcelRequire("1rUYR");

var $bdWwC = parcelRequire("bdWwC");

var $hNCHi = parcelRequire("hNCHi");

var $9rtUf = parcelRequire("9rtUf");
var $c92cc355bead10fe$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "xcss"
];
var $c92cc355bead10fe$var$fullWidthStyles = (0, $2ZUkg.css)({
    width: "100%"
});
var $c92cc355bead10fe$var$rootStyles = (0, $2ZUkg.css)((0, $9Ecwd.default)((0, $9Ecwd.default)({
    display: "block",
    boxSizing: "border-box",
    zIndex: (0, $1N6gx.layers).layer(),
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $hgdFQ.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $hgdFQ.N50A), ", 0 0 1px ").concat((0, $hgdFQ.N60A)), ")"),
    // Resetting text color for portal content.
    // Otherwise, when rendering into the parent (not using a portal),
    // the text color can be inherited from the parent.
    color: "var(--ds-text, #172B4D)"
}, (0, $1rUYR.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $hgdFQ.N0), ")")), "&:focus", {
    outline: "none"
}));
var $c92cc355bead10fe$var$scrollableStyles = (0, $2ZUkg.css)({
    overflow: "auto"
});
var $c92cc355bead10fe$var$blanketStyles = (0, $2ZUkg.css)({
    position: "fixed",
    inset: 0,
    backgroundColor: "var(--ds-blanket, #091E427D)"
});
var $c92cc355bead10fe$var$modalStyles = (0, $2ZUkg.css)({
    maxHeight: "50vh",
    position: "fixed",
    insetBlockStart: "var(--ds-space-050, 4px)",
    insetInline: "var(--ds-space-050, 4px)"
});
var $c92cc355bead10fe$var$DefaultPopupComponent = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, xcss = props.xcss, htmlAttributes = (0, $Zqzri.default)(props, $c92cc355bead10fe$var$_excluded);
    return (0, $2ZUkg.jsx)("div", (0, $y8mkn.default)({
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- This rule still fails because of the TS assertion
        className: xcss,
        css: [
            $c92cc355bead10fe$var$rootStyles,
            appearance === "UNSAFE_modal-below-sm" && $c92cc355bead10fe$var$modalStyles,
            !shouldRenderToParent && $c92cc355bead10fe$var$scrollableStyles,
            shouldFitContainer && $c92cc355bead10fe$var$fullWidthStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $c92cc355bead10fe$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $c92cc355bead10fe$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $glJen.default)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(null), _useState4 = (0, $glJen.default)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== "dialog";
    (0, $9rtUf.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $hNCHi.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $jIxbv.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $iSvIT.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, $2eRSM.default)(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return (0, $2ZUkg.jsx)((0, $gr749.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        var popupContainer = (0, $2ZUkg.jsx)(PopupContainer, {
            xcss: xcss,
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === "UNSAFE_modal-below-sm" ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, (0, $2ZUkg.jsx)((0, $bdWwC.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return !initialFocusRef && (0, $jxLBU.fg)("platform-design-system-apply-popup-wrapper-focus") ? (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, (0, $2ZUkg.jsx)((0, $7TCqn.default), null, popupContainer), appearance === "UNSAFE_modal-below-sm" && (0, $2ZUkg.jsx)("div", {
            css: $c92cc355bead10fe$var$blanketStyles
        })) : (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, popupContainer, appearance === "UNSAFE_modal-below-sm" && (0, $2ZUkg.jsx)("div", {
            css: $c92cc355bead10fe$var$blanketStyles
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c92cc355bead10fe$export$2e2bcd8739ae039 = $c92cc355bead10fe$var$PopperWrapper;

});
parcelRegister("jIxbv", function(module, exports) {

$parcel$export(module.exports, "useLayering", function () { return $e5abde28b814c15d$export$c8b4d54e03dee6ed; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $dfEzc = parcelRequire("dfEzc");
var $e5abde28b814c15d$var$ESCAPE = "Escape";
function $e5abde28b814c15d$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $iSvIT.useRef)(false);
    var _useLayering = $e5abde28b814c15d$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $iSvIT.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $e5abde28b814c15d$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $iSvIT.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $iSvIT.useEffect)(function() {
        return (0, $2e1kT.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $e5abde28b814c15d$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $iSvIT.useContext)((0, $dfEzc.LevelContext));
    var _useContext = (0, $iSvIT.useContext)((0, $dfEzc.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $iSvIT.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("bdWwC", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", function () { return $82be4e79f3a66f4c$export$51eddd7655ca235a; });

var $iSvIT = parcelRequire("iSvIT");
var $82be4e79f3a66f4c$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, children);
};

});

parcelRegister("hNCHi", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", function () { return $cf5507bcf00dfc15$export$92dae2778ae88f9d; });
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $4OZuI = parcelRequire("4OZuI");

var $jIxbv = parcelRequire("jIxbv");

var $jxLBU = parcelRequire("jxLBU");

var $bMnrX = parcelRequire("bMnrX");

var $4a5gG = parcelRequire("4a5gG");
var $cf5507bcf00dfc15$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $jIxbv.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $4a5gG.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $iSvIT.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $4OZuI.default;
        var inIframe = window && window.self !== window.top && (0, $jxLBU.fg)("fix-dropdown-close-outside-iframe");
        var closePopup = function closePopup(event) {
            if (onClose) {
                if ((0, $jxLBU.fg)("sibling-dropdown-close-issue")) {
                    var _currentLevel = null;
                    if (event.target instanceof HTMLElement) {
                        var _event$target$closest;
                        _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute("data-ds--level");
                    }
                    _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "0");
                if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "0");
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if ((0, $jxLBU.fg)("design-system-closed-all-when-click-outside")) {
                    if (target instanceof HTMLElement) {
                        var _target$closest;
                        var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                        if (layeredElement) {
                            var closeType = layeredElement.getAttribute("[data-ds--close--type]");
                            if (closeType === "single") // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            var levelOfClickedLayer = layeredElement.getAttribute("data-ds--level");
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                } else return;
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $bMnrX.isInteractiveElement)(document.activeElement) && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === "Tab" && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === "Tab") {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest("[aria-modal]")) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === "Escape" || key === "Esc") {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === "Escape" || _key === "Esc" || shouldCloseOnTab && _key === "Tab") closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $2e1kT.bind)(window.parent.window, {
            type: "click",
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $2e1kT.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $4OZuI.default);
        unbindBlur = (0, $2e1kT.bind)(window, {
            type: "blur",
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            cancelAllFrames();
            unbind();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("bMnrX", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", function () { return $89365e0d4b0ff7e4$export$3dee5e4542c672d9; });
var $89365e0d4b0ff7e4$var$interactiveTags = [
    "button",
    "a",
    "input",
    "select",
    "textarea"
];
var $89365e0d4b0ff7e4$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($89365e0d4b0ff7e4$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute("tabindex") !== null || element.hasAttribute("contenteditable")) return true;
    return false;
};

});

parcelRegister("4a5gG", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", function () { return $307c2eb93214c84d$export$641fa9c94086b46e; });

var $iSvIT = parcelRequire("iSvIT");
var $307c2eb93214c84d$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $iSvIT.useRef)([]);
    var requestFrame = (0, $iSvIT.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $iSvIT.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $iSvIT.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("9rtUf", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", function () { return $6dfdd571c831be2d$export$10c5169755ce7bd7; });

var $iSvIT = parcelRequire("iSvIT");

var $17K1G = parcelRequire("17K1G");

var $4OZuI = parcelRequire("4OZuI");

var $jIxbv = parcelRequire("jIxbv");

var $jxLBU = parcelRequire("jxLBU");

var $4a5gG = parcelRequire("4a5gG");
var $6dfdd571c831be2d$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $4a5gG.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $jIxbv.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $iSvIT.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $4OZuI.default;
        if (shouldDisableFocusTrap && (0, $jxLBU.fg)("platform_dst_popup-disable-focuslock")) {
            var isDropdown = popupRef.matches("[id^=ds--dropdown--]");
            var popups = document.querySelectorAll('[data-ds--level="'.concat(currentLevel - 1, '"]'));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "-1");
                    if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "-1");
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $4OZuI.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($17K1G)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("1NlOT", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", function () { return $14eb4b03595bafb0$export$4065aef1d79a5730; });

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $fIQbu = parcelRequire("fIQbu");
function $14eb4b03595bafb0$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $fIQbu.UNSAFE_useMediaQuery)("below.sm", function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $iSvIT.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, $glJen.default)(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === "UNSAFE_modal-below-sm" && isSmallViewport ? "UNSAFE_modal-below-sm" : "default";
    var shouldRenderToParent = _shouldRenderToParent && appearance === "default";
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("fIQbu", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $b72371c4f7ea685a$export$49e55ae2c03d6045; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $lJUzf = parcelRequire("lJUzf");

var $8jhLY = parcelRequire("8jhLY");
var $b72371c4f7ea685a$var$_window, $b72371c4f7ea685a$var$_window$matchMedia, $b72371c4f7ea685a$var$_window2, $b72371c4f7ea685a$var$_window2$matchMedia, $b72371c4f7ea685a$var$_window3, $b72371c4f7ea685a$var$_window3$matchMedia, $b72371c4f7ea685a$var$_window4, $b72371c4f7ea685a$var$_window4$matchMedia, $b72371c4f7ea685a$var$_window5, $b72371c4f7ea685a$var$_window5$matchMedia, $b72371c4f7ea685a$var$_window6, $b72371c4f7ea685a$var$_window6$matchMedia, $b72371c4f7ea685a$var$_window7, $b72371c4f7ea685a$var$_window7$matchMedia, $b72371c4f7ea685a$var$_window8, $b72371c4f7ea685a$var$_window8$matchMedia, $b72371c4f7ea685a$var$_window9, $b72371c4f7ea685a$var$_window9$matchMedia, $b72371c4f7ea685a$var$_window10, $b72371c4f7ea685a$var$_window10$matchMedia, $b72371c4f7ea685a$var$_window11, $b72371c4f7ea685a$var$_window11$matchMedia;
var $b72371c4f7ea685a$var$queries = {
    "above.xxs": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window = window) === null || $b72371c4f7ea685a$var$_window === void 0 || ($b72371c4f7ea685a$var$_window$matchMedia = $b72371c4f7ea685a$var$_window.matchMedia) === null || $b72371c4f7ea685a$var$_window$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window$matchMedia.call($b72371c4f7ea685a$var$_window, (0, $8jhLY.UNSAFE_media).above.xxs.replace("@media ", "").trim()),
    "above.xs": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window2 = window) === null || $b72371c4f7ea685a$var$_window2 === void 0 || ($b72371c4f7ea685a$var$_window2$matchMedia = $b72371c4f7ea685a$var$_window2.matchMedia) === null || $b72371c4f7ea685a$var$_window2$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window2$matchMedia.call($b72371c4f7ea685a$var$_window2, (0, $8jhLY.UNSAFE_media).above.xs.replace("@media ", "").trim()),
    "above.sm": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window3 = window) === null || $b72371c4f7ea685a$var$_window3 === void 0 || ($b72371c4f7ea685a$var$_window3$matchMedia = $b72371c4f7ea685a$var$_window3.matchMedia) === null || $b72371c4f7ea685a$var$_window3$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window3$matchMedia.call($b72371c4f7ea685a$var$_window3, (0, $8jhLY.UNSAFE_media).above.sm.replace("@media ", "").trim()),
    "above.md": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window4 = window) === null || $b72371c4f7ea685a$var$_window4 === void 0 || ($b72371c4f7ea685a$var$_window4$matchMedia = $b72371c4f7ea685a$var$_window4.matchMedia) === null || $b72371c4f7ea685a$var$_window4$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window4$matchMedia.call($b72371c4f7ea685a$var$_window4, (0, $8jhLY.UNSAFE_media).above.md.replace("@media ", "").trim()),
    "above.lg": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window5 = window) === null || $b72371c4f7ea685a$var$_window5 === void 0 || ($b72371c4f7ea685a$var$_window5$matchMedia = $b72371c4f7ea685a$var$_window5.matchMedia) === null || $b72371c4f7ea685a$var$_window5$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window5$matchMedia.call($b72371c4f7ea685a$var$_window5, (0, $8jhLY.UNSAFE_media).above.lg.replace("@media ", "").trim()),
    "above.xl": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window6 = window) === null || $b72371c4f7ea685a$var$_window6 === void 0 || ($b72371c4f7ea685a$var$_window6$matchMedia = $b72371c4f7ea685a$var$_window6.matchMedia) === null || $b72371c4f7ea685a$var$_window6$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window6$matchMedia.call($b72371c4f7ea685a$var$_window6, (0, $8jhLY.UNSAFE_media).above.xl.replace("@media ", "").trim()),
    "below.xs": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window7 = window) === null || $b72371c4f7ea685a$var$_window7 === void 0 || ($b72371c4f7ea685a$var$_window7$matchMedia = $b72371c4f7ea685a$var$_window7.matchMedia) === null || $b72371c4f7ea685a$var$_window7$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window7$matchMedia.call($b72371c4f7ea685a$var$_window7, (0, $8jhLY.UNSAFE_media).below.xs.replace("@media ", "").trim()),
    "below.sm": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window8 = window) === null || $b72371c4f7ea685a$var$_window8 === void 0 || ($b72371c4f7ea685a$var$_window8$matchMedia = $b72371c4f7ea685a$var$_window8.matchMedia) === null || $b72371c4f7ea685a$var$_window8$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window8$matchMedia.call($b72371c4f7ea685a$var$_window8, (0, $8jhLY.UNSAFE_media).below.sm.replace("@media ", "").trim()),
    "below.md": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window9 = window) === null || $b72371c4f7ea685a$var$_window9 === void 0 || ($b72371c4f7ea685a$var$_window9$matchMedia = $b72371c4f7ea685a$var$_window9.matchMedia) === null || $b72371c4f7ea685a$var$_window9$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window9$matchMedia.call($b72371c4f7ea685a$var$_window9, (0, $8jhLY.UNSAFE_media).below.md.replace("@media ", "").trim()),
    "below.lg": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window10 = window) === null || $b72371c4f7ea685a$var$_window10 === void 0 || ($b72371c4f7ea685a$var$_window10$matchMedia = $b72371c4f7ea685a$var$_window10.matchMedia) === null || $b72371c4f7ea685a$var$_window10$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window10$matchMedia.call($b72371c4f7ea685a$var$_window10, (0, $8jhLY.UNSAFE_media).below.lg.replace("@media ", "").trim()),
    "below.xl": typeof window === "undefined" ? undefined : ($b72371c4f7ea685a$var$_window11 = window) === null || $b72371c4f7ea685a$var$_window11 === void 0 || ($b72371c4f7ea685a$var$_window11$matchMedia = $b72371c4f7ea685a$var$_window11.matchMedia) === null || $b72371c4f7ea685a$var$_window11$matchMedia === void 0 ? void 0 : $b72371c4f7ea685a$var$_window11$matchMedia.call($b72371c4f7ea685a$var$_window11, (0, $8jhLY.UNSAFE_media).below.xl.replace("@media ", "").trim())
};
var $b72371c4f7ea685a$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $iSvIT.useRef)(listener);
    (0, $iSvIT.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $b72371c4f7ea685a$var$queries[queryString];
    (0, $lJUzf.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $2e1kT.bind)(mq, {
            type: "change",
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("lJUzf", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $fd39ae14c4f3d88e$export$e5c5a5f917a5871c; });

var $iSvIT = parcelRequire("iSvIT");
var $fd39ae14c4f3d88e$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);

});

parcelRegister("8jhLY", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_media", function () { return $60cde26637cef28c$export$c881183ca713c214; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $60cde26637cef28c$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $60cde26637cef28c$export$c881183ca713c214 = $60cde26637cef28c$export$987d49ffe1b0900f;

});



parcelRegister("d5ZeW", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $988b3efa7301e230$export$7cc5c058dd769dff; });

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $fV0Sg = parcelRequire("fV0Sg");
var $988b3efa7301e230$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $iSvIT.useState)(function() {
        return (0, $fV0Sg.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $glJen.default)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("1iE5l", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $0f2690f7c89b2676$export$5d3a2de79e07b376; });

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $fV0Sg = parcelRequire("fV0Sg");
var $0f2690f7c89b2676$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $iSvIT.useState)(function() {
        return (0, $fV0Sg.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $glJen.default)(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("eCrfe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa49bf80fc37f5ae$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $glJen = parcelRequire("glJen");

var $9Ecwd = parcelRequire("9Ecwd");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $5C7oI = parcelRequire("5C7oI");

var $4OZuI = parcelRequire("4OZuI");

var $2uvCZ = parcelRequire("2uvCZ");

var $5dQuO = parcelRequire("5dQuO");

var $fYyCi = parcelRequire("fYyCi");

var $erEAn = parcelRequire("erEAn");
var $g9l3b = parcelRequire("g9l3b");

var $gr749 = parcelRequire("gr749");

var $7g0z5 = parcelRequire("7g0z5");

var $1N6gx = parcelRequire("1N6gx");

var $6U5hJ = parcelRequire("6U5hJ");

var $eqm4i = parcelRequire("eqm4i");

var $jFw7R = parcelRequire("jFw7R");

var $ePpgT = parcelRequire("ePpgT");

var $apBwl = parcelRequire("apBwl");
function $aa49bf80fc37f5ae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aa49bf80fc37f5ae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aa49bf80fc37f5ae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aa49bf80fc37f5ae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aa49bf80fc37f5ae$var$tooltipZIndex = (0, $1N6gx.layers).tooltip();
var $aa49bf80fc37f5ae$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.0.1"
};
// Inverts motion direction
var $aa49bf80fc37f5ae$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $aa49bf80fc37f5ae$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $aa49bf80fc37f5ae$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $ePpgT.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $4OZuI.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $4OZuI.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $5C7oI.usePlatformLeafSyntheticEventHandler)($aa49bf80fc37f5ae$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $aa49bf80fc37f5ae$var$analyticsAttributes));
    var onHideHandler = (0, $5C7oI.usePlatformLeafSyntheticEventHandler)($aa49bf80fc37f5ae$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $aa49bf80fc37f5ae$var$analyticsAttributes));
    var apiRef = (0, $iSvIT.useRef)(null);
    var _useState = (0, $iSvIT.useState)("hide"), _useState2 = (0, $glJen.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $iSvIT.useRef)(null);
    var containerRef = (0, $iSvIT.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $iSvIT.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $5dQuO.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $5dQuO.default)(onShowHandler);
    var onHideHandlerStable = (0, $5dQuO.default)(onHideHandler);
    var delayStable = (0, $5dQuO.default)(delay);
    var canAppearStable = (0, $5dQuO.default)(canAppear);
    var hasCalledShowHandler = (0, $iSvIT.useRef)(false);
    var start = (0, $iSvIT.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $iSvIT.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $iSvIT.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $iSvIT.useRef)(false);
    (0, $iSvIT.useEffect)(function() {
        return (0, $6U5hJ.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $iSvIT.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $eqm4i.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $iSvIT.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $2uvCZ.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $iSvIT.useEffect)(function() {
        if (state === "hide") return 0, $4OZuI.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $2e1kT.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $iSvIT.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $apBwl.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $iSvIT.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $apBwl.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $iSvIT.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $iSvIT.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $iSvIT.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    (0, $fYyCi.useNotifyOpenLayerObserver)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $jFw7R.default)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $iSvIT.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children($aa49bf80fc37f5ae$var$_objectSpread($aa49bf80fc37f5ae$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(CastTargetContainer, (0, $y8mkn.default)({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7g0z5.default), {
        zIndex: $aa49bf80fc37f5ae$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gr749.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $aa49bf80fc37f5ae$var$invertedDirection[$aa49bf80fc37f5ae$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $erEAn.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $g9l3b.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $aa49bf80fc37f5ae$var$_objectSpread($aa49bf80fc37f5ae$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$aa49bf80fc37f5ae$var$Tooltip.displayName = "Tooltip";
var $aa49bf80fc37f5ae$export$2e2bcd8739ae039 = $aa49bf80fc37f5ae$var$Tooltip;

});
parcelRegister("5C7oI", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $41663d5f08a69106$export$1a04351537078b55; });

var $9Ecwd = parcelRequire("9Ecwd");

var $iSvIT = parcelRequire("iSvIT");

var $l2DxG = parcelRequire("l2DxG");

var $dLwLz = parcelRequire("dLwLz");
function $41663d5f08a69106$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41663d5f08a69106$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41663d5f08a69106$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41663d5f08a69106$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41663d5f08a69106$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $l2DxG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $dLwLz.useTrackedRef)(analyticsData);
    var fnRef = (0, $dLwLz.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $41663d5f08a69106$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("dLwLz", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $a05914d22d705320$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $a05914d22d705320$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("erEAn", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $a84311cb07c80b4c$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $a84311cb07c80b4c$export$2e2bcd8739ae039; });

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $4dCNA = parcelRequire("4dCNA");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $a84311cb07c80b4c$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $a84311cb07c80b4c$var$ExitingContext = /*#__PURE__*/ (0, $iSvIT.createContext)($a84311cb07c80b4c$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $a84311cb07c80b4c$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a84311cb07c80b4c$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($a84311cb07c80b4c$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $a84311cb07c80b4c$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $iSvIT.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $a84311cb07c80b4c$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $a84311cb07c80b4c$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $a84311cb07c80b4c$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $a84311cb07c80b4c$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $a84311cb07c80b4c$var$ExitingPersistence = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $iSvIT.useState)([
        null,
        children
    ]), _useState2 = (0, $glJen.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)([]), _useState4 = (0, $glJen.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, $glJen.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $iSvIT.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $4dCNA.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, $glJen.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $a84311cb07c80b4c$var$childrenToArray(previousChildren);
    var current = $a84311cb07c80b4c$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $a84311cb07c80b4c$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $a84311cb07c80b4c$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $a84311cb07c80b4c$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $a84311cb07c80b4c$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $a84311cb07c80b4c$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $iSvIT.useContext)($a84311cb07c80b4c$var$ExitingContext);
};
$a84311cb07c80b4c$var$ExitingPersistence.displayName = "ExitingPersistence";
var $a84311cb07c80b4c$export$2e2bcd8739ae039 = $a84311cb07c80b4c$var$ExitingPersistence;

});
parcelRegister("4dCNA", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $312678f54e022d34$export$b7baf7667a68d87c; });

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");
var $312678f54e022d34$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $312678f54e022d34$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$312678f54e022d34$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $312678f54e022d34$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $iSvIT.useState)($312678f54e022d34$export$b7baf7667a68d87c), _useState2 = (0, $glJen.default)(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        if (!$312678f54e022d34$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $2e1kT.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $312678f54e022d34$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $312678f54e022d34$export$ff7706047246b98b = function prefersReducedMotion() {
    return $312678f54e022d34$export$f0f789643ba5a83c;
};

});


parcelRegister("g9l3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc1dd0bf69fa27c8$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $48U7w = parcelRequire("48U7w");
var $bc1dd0bf69fa27c8$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $bc1dd0bf69fa27c8$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $bc1dd0bf69fa27c8$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-out";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $48U7w.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-in",
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $bc1dd0bf69fa27c8$export$2e2bcd8739ae039 = $bc1dd0bf69fa27c8$var$FadeIn;

});
parcelRegister("48U7w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30437117cd27912f$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $f4dOm = parcelRequire("f4dOm");

var $UnZP2 = parcelRequire("UnZP2");

var $hlpYo = parcelRequire("hlpYo");

var $erEAn = parcelRequire("erEAn");

var $joaCc = parcelRequire("joaCc");
var $30437117cd27912f$var$zoomIn = null;
var $30437117cd27912f$var$zoomOut = null;
var $30437117cd27912f$var$fadeIn = null;
var $30437117cd27912f$var$fadeOut = null;
var $30437117cd27912f$var$fadeInFromTop = null;
var $30437117cd27912f$var$fadeOutFromTop = null;
var $30437117cd27912f$var$fadeInFromLeft = null;
var $30437117cd27912f$var$fadeOutFromLeft = null;
var $30437117cd27912f$var$fadeInFromBottom = null;
var $30437117cd27912f$var$fadeOutFromBottom = null;
var $30437117cd27912f$var$fadeInFromRight = null;
var $30437117cd27912f$var$fadeOutFromRight = null;
var $30437117cd27912f$var$fadeInFromTopConstant = null;
var $30437117cd27912f$var$fadeOutFromTopConstant = null;
var $30437117cd27912f$var$fadeInFromLeftConstant = null;
var $30437117cd27912f$var$fadeOutFromLeftConstant = null;
var $30437117cd27912f$var$fadeInFromBottomConstant = null;
var $30437117cd27912f$var$fadeOutFromBottomConstant = null;
var $30437117cd27912f$var$fadeInFromRightConstant = null;
var $30437117cd27912f$var$fadeOutFromRightConstant = null;
var $30437117cd27912f$var$slideInFromTop = null;
var $30437117cd27912f$var$slideOutFromTop = null;
var $30437117cd27912f$var$slideInFromRight = null;
var $30437117cd27912f$var$slideOutFromRight = null;
var $30437117cd27912f$var$slideInFromBottom = null;
var $30437117cd27912f$var$slideOutFromBottom = null;
var $30437117cd27912f$var$slideInFromLeft = null;
var $30437117cd27912f$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $30437117cd27912f$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $joaCc.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $erEAn.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $hlpYo.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $iSvIT.useState)(appear), _useState2 = (0, $glJen.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? (0, $UnZP2.exitingDurations)[duration] : (0, $UnZP2.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $f4dOm.default)([
            (0, $f4dOm.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $f4dOm.default)([
                "_1y0ctrqk"
            ]),
            duration === "small" && (0, $f4dOm.default)([
                "_5sag1yx9"
            ]),
            duration === "medium" && (0, $f4dOm.default)([
                "_5sag1ttt"
            ]),
            duration === "large" && (0, $f4dOm.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === "small" && (0, $f4dOm.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === "medium" && (0, $f4dOm.default)([
                "_5sagluct"
            ]),
            isExiting && duration === "large" && (0, $f4dOm.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $f4dOm.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === "linear" && (0, $f4dOm.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === "ease-out" && (0, $f4dOm.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === "ease-in" && (0, $f4dOm.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === "ease-in-out" && (0, $f4dOm.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === "linear" && (0, $f4dOm.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-out" && (0, $f4dOm.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in" && (0, $f4dOm.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-out" && (0, $f4dOm.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === "fade-in" || isExiting && exitingAnimation === "fade-in") && (0, $f4dOm.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === "fade-out" || isExiting && exitingAnimation === "fade-out") && (0, $f4dOm.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === "zoom-in" || isExiting && exitingAnimation === "zoom-in") && (0, $f4dOm.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === "zoom-out" || isExiting && exitingAnimation === "zoom-out") && (0, $f4dOm.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-top" || isExiting && exitingAnimation === "slide-in-from-top") && (0, $f4dOm.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-top" || isExiting && exitingAnimation === "slide-out-from-top") && (0, $f4dOm.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-right" || isExiting && exitingAnimation === "slide-in-from-right") && (0, $f4dOm.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-right" || isExiting && exitingAnimation === "slide-out-from-right") && (0, $f4dOm.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-bottom" || isExiting && exitingAnimation === "slide-in-from-bottom") && (0, $f4dOm.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-bottom" || isExiting && exitingAnimation === "slide-out-from-bottom") && (0, $f4dOm.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-left" || isExiting && exitingAnimation === "slide-in-from-left") && (0, $f4dOm.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-left" || isExiting && exitingAnimation === "slide-out-from-left") && (0, $f4dOm.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top" || isExiting && exitingAnimation === "fade-in-from-top") && (0, $f4dOm.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top" || isExiting && exitingAnimation === "fade-out-from-top") && (0, $f4dOm.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left" || isExiting && exitingAnimation === "fade-in-from-left") && (0, $f4dOm.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left" || isExiting && exitingAnimation === "fade-out-from-left") && (0, $f4dOm.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom" || isExiting && exitingAnimation === "fade-in-from-bottom") && (0, $f4dOm.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom" || isExiting && exitingAnimation === "fade-out-from-bottom") && (0, $f4dOm.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right" || isExiting && exitingAnimation === "fade-in-from-right") && (0, $f4dOm.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right" || isExiting && exitingAnimation === "fade-out-from-right") && (0, $f4dOm.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top-constant" || isExiting && exitingAnimation === "fade-in-from-top-constant") && (0, $f4dOm.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top-constant" || isExiting && exitingAnimation === "fade-out-from-top-constant") && (0, $f4dOm.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left-constant" || isExiting && exitingAnimation === "fade-in-from-left-constant") && (0, $f4dOm.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left-constant" || isExiting && exitingAnimation === "fade-out-from-left-constant") && (0, $f4dOm.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom-constant" || isExiting && exitingAnimation === "fade-in-from-bottom-constant") && (0, $f4dOm.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom-constant" || isExiting && exitingAnimation === "fade-out-from-bottom-constant") && (0, $f4dOm.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right-constant" || isExiting && exitingAnimation === "fade-in-from-right-constant") && (0, $f4dOm.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right-constant" || isExiting && exitingAnimation === "fade-out-from-right-constant") && (0, $f4dOm.default)([
                "_j7hq1pgp"
            ])
        ]) : "",
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $30437117cd27912f$export$2e2bcd8739ae039 = $30437117cd27912f$var$EnteringMotion;

});
parcelRegister("f4dOm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af81f157ec3c1cb7$export$2e2bcd8739ae039; });
const $af81f157ec3c1cb7$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $af81f157ec3c1cb7$var$ATOMIC_GROUP_LENGTH = 5;
function $af81f157ec3c1cb7$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $af81f157ec3c1cb7$var$UNDERSCORE_UNICODE ? $af81f157ec3c1cb7$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("UnZP2", function(module, exports) {

$parcel$export(module.exports, "durations", function () { return $0a97d835933d9268$export$38b928a7167ce124; });
$parcel$export(module.exports, "exitingDurations", function () { return $0a97d835933d9268$export$30fa1a2e62ae150c; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $0a97d835933d9268$export$368bacef0dacbe05 = 25;
var $0a97d835933d9268$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $0a97d835933d9268$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $0a97d835933d9268$export$30fa1a2e62ae150c = {
    none: $0a97d835933d9268$export$38b928a7167ce124.none,
    small: $0a97d835933d9268$export$38b928a7167ce124.small * $0a97d835933d9268$var$EXITING_MOTION_MULTIPLIER,
    medium: $0a97d835933d9268$export$38b928a7167ce124.medium * $0a97d835933d9268$var$EXITING_MOTION_MULTIPLIER,
    large: $0a97d835933d9268$export$38b928a7167ce124.large * $0a97d835933d9268$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("hlpYo", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $ca088b884ca289eb$export$4f34107a2b00f39c; });

var $iSvIT = parcelRequire("iSvIT");
var $ca088b884ca289eb$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $ca088b884ca289eb$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $iSvIT.useRef)([]);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $ca088b884ca289eb$var$getHookDeps(opts));
    return (0, $iSvIT.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $ca088b884ca289eb$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $iSvIT.useRef)([]);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $ca088b884ca289eb$var$getHookDeps(opts));
    return (0, $iSvIT.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("joaCc", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $e1d87e22f5930883$export$25c7213fc07ec080; });

var $glJen = parcelRequire("glJen");

var $iSvIT = parcelRequire("iSvIT");

var $4OZuI = parcelRequire("4OZuI");

var $4b10T = parcelRequire("4b10T");

var $3YMqo = parcelRequire("3YMqo");
var $e1d87e22f5930883$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $iSvIT.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $4OZuI.default)
    };
});
var $e1d87e22f5930883$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $3YMqo.useUniqueId)();
    var context = (0, $iSvIT.useContext)($e1d87e22f5930883$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $e1d87e22f5930883$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $iSvIT.useRef)([]);
    var indexes = [];
    var _useState = (0, $iSvIT.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $glJen.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $4b10T.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($e1d87e22f5930883$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $e1d87e22f5930883$export$2e2bcd8739ae039 = $e1d87e22f5930883$var$StaggeredEntrance;

});
parcelRegister("4b10T", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $30a8f9c084fbbfd3$export$e5c5a5f917a5871c; });

var $iSvIT = parcelRequire("iSvIT");
var $30a8f9c084fbbfd3$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);

});

parcelRegister("3YMqo", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $2e5c89cec2d9a516$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $iSvIT = parcelRequire("iSvIT");
function $2e5c89cec2d9a516$export$c485849f2e393253() {
    var identifier = (0, $iSvIT.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("6U5hJ", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $014c10d08e42121b$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $2e1kT = parcelRequire("2e1kT");
var $014c10d08e42121b$var$registrations = new Set();
var $014c10d08e42121b$var$cleanupEndEventListeners = null;
function $014c10d08e42121b$var$onDragStart() {
    if ($014c10d08e42121b$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $014c10d08e42121b$var$cleanupEndEventListeners = (0, $2e1kT.bindAll)(window, [
        {
            type: "dragend",
            listener: $014c10d08e42121b$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $014c10d08e42121b$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $014c10d08e42121b$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($014c10d08e42121b$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $014c10d08e42121b$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $014c10d08e42121b$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $014c10d08e42121b$var$cleanupEndEventListeners = null;
    var clone = Array.from($014c10d08e42121b$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $014c10d08e42121b$var$bindStartEvents() {
    return (0, $2e1kT.bindAll)(window, [
        {
            type: "dragstart",
            listener: $014c10d08e42121b$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $014c10d08e42121b$var$onDragStart
        }
    ]);
}
var $014c10d08e42121b$var$cleanupStartEventListeners = null;
function $014c10d08e42121b$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$014c10d08e42121b$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $014c10d08e42121b$var$cleanupStartEventListeners = $014c10d08e42121b$var$bindStartEvents();
    $014c10d08e42121b$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $014c10d08e42121b$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $014c10d08e42121b$var$registrations.delete(registration);
        if ($014c10d08e42121b$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $014c10d08e42121b$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $014c10d08e42121b$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("eqm4i", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $a8049cb653d20938$export$57bf213be019eeb0; });

var $bu7SC = parcelRequire("bu7SC");
// This file is a singleton for managing tooltips
var $a8049cb653d20938$var$active = null;
function $a8049cb653d20938$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($a8049cb653d20938$var$active && $a8049cb653d20938$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $bu7SC.clearScheduled)();
            $a8049cb653d20938$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $bu7SC.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $bu7SC.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $bu7SC.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($a8049cb653d20938$var$active && $a8049cb653d20938$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($a8049cb653d20938$var$active) {
            (0, $bu7SC.clearScheduled)();
            $a8049cb653d20938$var$active.entry.hide({
                isImmediate: true
            });
            $a8049cb653d20938$var$active.entry.done();
            $a8049cb653d20938$var$active = null;
        }
        // this tooltip is now the active tooltip
        $a8049cb653d20938$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $bu7SC.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("bu7SC", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $85c89bd341eaa0b0$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $85c89bd341eaa0b0$export$5f4d6617421d489b; });
var $85c89bd341eaa0b0$var$delayId = null;
function $85c89bd341eaa0b0$export$eaf678f6f93f5250() {
    if ($85c89bd341eaa0b0$var$delayId != null) {
        window.clearTimeout($85c89bd341eaa0b0$var$delayId);
        $85c89bd341eaa0b0$var$delayId = null;
    }
}
function $85c89bd341eaa0b0$export$5f4d6617421d489b(fn, delay) {
    $85c89bd341eaa0b0$export$eaf678f6f93f5250();
    $85c89bd341eaa0b0$var$delayId = window.setTimeout(function() {
        $85c89bd341eaa0b0$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("jFw7R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e51ac425e622e6c0$export$2e2bcd8739ae039; });

var $dWwnB = parcelRequire("dWwnB");
function $e51ac425e622e6c0$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $dWwnB.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("ePpgT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acb96e78804f425e$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9Ecwd = parcelRequire("9Ecwd");

var $iSvIT = parcelRequire("iSvIT");

var $f4dOm = parcelRequire("f4dOm");
var $atajj = parcelRequire("atajj");

var $hgdFQ = parcelRequire("hgdFQ");

var $7yxxm = parcelRequire("7yxxm");
function $acb96e78804f425e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acb96e78804f425e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acb96e78804f425e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acb96e78804f425e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $acb96e78804f425e$var$baseStyles = null;
var $acb96e78804f425e$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $acb96e78804f425e$var$TooltipContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $iSvIT.createElement((0, $7yxxm.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $f4dOm.default)([
            "_2rko1sit _11c8qk37 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $acb96e78804f425e$var$_objectSpread($acb96e78804f425e$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $atajj.default)("var(--ds-background-neutral-bold, ".concat((0, $hgdFQ.N800), ")")),
            "--_ywovvi": (0, $atajj.default)("var(--ds-text-inverse, ".concat((0, $hgdFQ.N0), ")"))
        })
    }, children);
});
$acb96e78804f425e$var$TooltipContainer.displayName = "TooltipContainer";
var $acb96e78804f425e$export$2e2bcd8739ae039 = $acb96e78804f425e$var$TooltipContainer;

});
parcelRegister("atajj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79f49c3e39444a13$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $79f49c3e39444a13$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("7yxxm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5805b92b04871ff7$export$2e2bcd8739ae039; });

var $9Ecwd = parcelRequire("9Ecwd");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $1N6gx = parcelRequire("1N6gx");
function $5805b92b04871ff7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5805b92b04871ff7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5805b92b04871ff7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5805b92b04871ff7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5805b92b04871ff7$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $5805b92b04871ff7$var$primitiveStyles = (0, $2ZUkg.css)({
    zindex: "var(".concat($5805b92b04871ff7$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $5805b92b04871ff7$var$TooltipPrimitive = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $5805b92b04871ff7$var$_objectSpread($5805b92b04871ff7$var$_objectSpread({}, style), {}, (0, $9Ecwd.default)({}, $5805b92b04871ff7$var$VAR_PRIMITIVE_ZINDEX, (0, $1N6gx.layers).tooltip()));
    return (0, $2ZUkg.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $2ZUkg.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $5805b92b04871ff7$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$5805b92b04871ff7$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $5805b92b04871ff7$export$2e2bcd8739ae039 = $5805b92b04871ff7$var$TooltipPrimitive;

});


parcelRegister("apBwl", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $794957fd1cddf9df$export$642213d516a9b928; });
function $794957fd1cddf9df$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("6222Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $464484899ead0d5e$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $iSvIT = parcelRequire("iSvIT");

var $fO5Qk = parcelRequire("fO5Qk");

var $lL4Ma = parcelRequire("lL4Ma");

var $1xWvU = parcelRequire("1xWvU");
var $lPJK3 = parcelRequire("lPJK3");
var $5EWjr = parcelRequire("5EWjr");

var $lEdbm = parcelRequire("lEdbm");
var $464484899ead0d5e$var$_excluded = [
    "analyticsContext",
    "appearance",
    "as",
    "borderColor",
    "children",
    "href",
    "isDisabled",
    "key",
    "label",
    "name",
    "onClick",
    "presence",
    "size",
    "src",
    "stackIndex",
    "status",
    "tabIndex",
    "target",
    "testId"
], $464484899ead0d5e$var$_excluded2 = [
    "children",
    "className",
    "disabled",
    "draggable",
    "onClick",
    "onDragStart",
    "onMouseDown",
    "ref",
    "tabIndex",
    "data-testid"
];
var $464484899ead0d5e$var$AvatarGroupItem = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var avatar = props.avatar, index = props.index, onAvatarClick = props.onAvatarClick, testId = props.testId;
    var analyticsContext = avatar.analyticsContext, appearance = avatar.appearance, as = avatar.as, borderColor = avatar.borderColor, children = avatar.children, href = avatar.href, isDisabled = avatar.isDisabled, key = avatar.key, label = avatar.label, name = avatar.name, onClick = avatar.onClick, presence = avatar.presence, size = avatar.size, src = avatar.src, stackIndex = avatar.stackIndex, status = avatar.status, tabIndex = avatar.tabIndex, target = avatar.target, groupItemTestId = avatar.testId, rest = (0, $Zqzri.default)(avatar, $464484899ead0d5e$var$_excluded);
    var itemRef = (0, $lEdbm.default)();
    var CustomComponent = function CustomComponent(_ref) {
        var children = _ref.children, className = _ref.className, disabled = _ref.disabled, draggable = _ref.draggable, onClick = _ref.onClick, onDragStart = _ref.onDragStart, onMouseDown = _ref.onMouseDown, ref = _ref.ref, tabIndex = _ref.tabIndex, testId = _ref["data-testid"], props = (0, $Zqzri.default)(_ref, $464484899ead0d5e$var$_excluded2);
        return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("button", (0, $y8mkn.default)({
            type: "button",
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId
        }, props), children));
    };
    var AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $fO5Qk.default), (0, $y8mkn.default)({}, rest, {
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && "".concat(testId, "--avatar")
    }));
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    var callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5EWjr.default), {
        ref: (0, $lL4Ma.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === "_blank" ? "noopener noreferrer" : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: function onClick(event) {
            return callback && callback(event, undefined, index);
        }
    }, name);
    if (typeof callback === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1xWvU.default), {
        ref: (0, $lL4Ma.default)([
            ref,
            itemRef
        ]),
        onClick: function onClick(event) {
            return callback && callback(event, undefined, index);
        },
        iconBefore: AvatarIcon,
        testId: testId
    }, name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lPJK3.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$464484899ead0d5e$export$2e2bcd8739ae039 = $464484899ead0d5e$var$AvatarGroupItem;

});
parcelRegister("1xWvU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1206431b32f30631$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $KsdEf = parcelRequire("KsdEf");

var $4OZuI = parcelRequire("4OZuI");

var $3rBsW = parcelRequire("3rBsW");

var $jxLBU = parcelRequire("jxLBU");

var $hIRze = parcelRequire("hIRze");
var $1206431b32f30631$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $1206431b32f30631$var$ButtonItem = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $4OZuI.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, $Zqzri.default)(props, $1206431b32f30631$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $iSvIT.useContext)((0, $3rBsW.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $KsdEf.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $4OZuI.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $2ZUkg.jsx)((0, $hIRze.default), (0, $y8mkn.default)({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $2ZUkg.jsx)("button", (0, $y8mkn.default)({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $jxLBU.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $1206431b32f30631$export$2e2bcd8739ae039 = $1206431b32f30631$var$ButtonItem;

});
parcelRegister("3rBsW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2820f4a59800be3d$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $2820f4a59800be3d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});

parcelRegister("hIRze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce7019158be2e336$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $KsdEf = parcelRequire("KsdEf");

var $7TCqn = parcelRequire("7TCqn");

var $b2Mer = parcelRequire("b2Mer");
var $gSxcF = parcelRequire("gSxcF");
var $h4hoY = parcelRequire("h4hoY");

var $hgdFQ = parcelRequire("hgdFQ");

var $6eEpC = parcelRequire("6eEpC");
var $ce7019158be2e336$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $2ZUkg.jsx)(Component, props));
};
var $ce7019158be2e336$var$beforeAfterElementStyles = (0, $2ZUkg.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $ce7019158be2e336$var$contentStyles = (0, $h4hoY.xcss)({
    outline: "none",
    overflow: "hidden",
    textAlign: "left"
});
var $ce7019158be2e336$var$truncateStyles = (0, $2ZUkg.css)({
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $ce7019158be2e336$var$titleStyles = (0, $2ZUkg.css)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $ce7019158be2e336$var$wordBreakStyles = (0, $2ZUkg.css)({
    wordBreak: "break-word"
});
var $ce7019158be2e336$var$descriptionStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $hgdFQ.N200), ")"),
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $ce7019158be2e336$var$disabledDescriptionStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-disabled, ".concat((0, $hgdFQ.N200), ")")
});
var $ce7019158be2e336$var$positionRelativeStyles = (0, $2ZUkg.css)({
    position: "relative"
});
var $ce7019158be2e336$var$primitiveStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: "center",
    border: 0,
    outline: 0,
    textDecoration: "none",
    userSelect: "none",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&::-moz-focus-inner": {
        border: 0
    },
    "&:hover": {
        textDecoration: "none"
    }
});
var $ce7019158be2e336$var$spacingMapStyles = {
    cozy: (0, $2ZUkg.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $2ZUkg.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $ce7019158be2e336$var$interactiveStyles = (0, $2ZUkg.css)({
    cursor: "pointer"
});
var $ce7019158be2e336$var$unselectedStyles = (0, $2ZUkg.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: "currentColor",
    "&:visited": {
        color: "currentColor"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $hgdFQ.N20), ")"),
        color: "currentColor"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $hgdFQ.N30), ")"),
        boxShadow: "none",
        color: "currentColor"
    }
});
var $ce7019158be2e336$var$disabledStyles = (0, $2ZUkg.css)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&, :hover, :active": {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $hgdFQ.N200), ")")
    }
});
var $ce7019158be2e336$var$selectedBorderStyles = (0, $2ZUkg.css)({
    "&::before": {
        width: 2,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $ce7019158be2e336$var$selectedNotchStyles = (0, $2ZUkg.css)({
    "&::before": {
        width: 4,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $ce7019158be2e336$var$selectedStyles = (0, $2ZUkg.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $hgdFQ.N20), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    "&:visited": {
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $hgdFQ.N20), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $hgdFQ.N30), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $ce7019158be2e336$var$gapMap = {
    compact: "space.100",
    cozy: "space.150"
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $ce7019158be2e336$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $KsdEf.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $iSvIT.useContext)((0, $6eEpC.SpacingContext));
    var selectionStyle = (0, $iSvIT.useContext)((0, $6eEpC.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $ce7019158be2e336$var$defaultRender;
    var UNSAFE_className = UNSAFE_externalClassName;
    return (0, $2ZUkg.jsx)((0, $2ZUkg.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $2ZUkg.jsx)((0, $7TCqn.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $ce7019158be2e336$var$positionRelativeStyles,
                    $ce7019158be2e336$var$primitiveStyles,
                    $ce7019158be2e336$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $ce7019158be2e336$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $ce7019158be2e336$var$selectedStyles,
                        [
                            selectionStyle === "border" && $ce7019158be2e336$var$selectedBorderStyles,
                            selectionStyle === "notch" && $ce7019158be2e336$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $ce7019158be2e336$var$disabledStyles : $ce7019158be2e336$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $2ZUkg.jsx)((0, $b2Mer.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $ce7019158be2e336$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $2ZUkg.jsx)("span", {
                "data-item-elem-before": true,
                css: $ce7019158be2e336$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $2ZUkg.jsx)((0, $gSxcF.default), {
                alignBlock: "center",
                grow: "fill",
                xcss: $ce7019158be2e336$var$contentStyles
            }, renderTitle("span", {
                children: title,
                className: cn($ce7019158be2e336$var$titleStyles, shouldTitleWrap ? $ce7019158be2e336$var$wordBreakStyles : $ce7019158be2e336$var$truncateStyles),
                "data-item-title": true
            }), description && (0, $2ZUkg.jsx)("span", {
                "data-item-description": true,
                css: [
                    $ce7019158be2e336$var$descriptionStyles,
                    isDisabled && $ce7019158be2e336$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $ce7019158be2e336$var$wordBreakStyles : $ce7019158be2e336$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $2ZUkg.jsx)("span", {
                "data-item-elem-after": true,
                css: $ce7019158be2e336$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $ce7019158be2e336$export$2e2bcd8739ae039 = $ce7019158be2e336$var$MenuItemPrimitive;

});
parcelRegister("b2Mer", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80a54b73ef5e2120$export$2e2bcd8739ae039; });

var $2eRSM = parcelRequire("2eRSM");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $h4hoY = parcelRequire("h4hoY");

var $32o0T = parcelRequire("32o0T");
var $80a54b73ef5e2120$var$flexGrowMap = {
    hug: (0, $h4hoY.xcss)({
        flexGrow: 0
    }),
    fill: (0, $h4hoY.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $80a54b73ef5e2120$var$separatorStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $80a54b73ef5e2120$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $80a54b73ef5e2120$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $80a54b73ef5e2120$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $2ZUkg.jsx)($80a54b73ef5e2120$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $80a54b73ef5e2120$var$flexGrowMap[grow]
    ].concat((0, $2eRSM.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $2ZUkg.jsx)((0, $32o0T.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$80a54b73ef5e2120$var$Inline.displayName = "Inline";
var $80a54b73ef5e2120$export$2e2bcd8739ae039 = $80a54b73ef5e2120$var$Inline;

});
parcelRegister("32o0T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23642f9233274671$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $igww8 = parcelRequire("igww8");

var $h4hoY = parcelRequire("h4hoY");
var $23642f9233274671$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $23642f9233274671$var$flexDirectionMap = {
    column: (0, $2ZUkg.css)({
        flexDirection: "column"
    }),
    row: (0, $2ZUkg.css)({
        flexDirection: "row"
    })
};
var $23642f9233274671$var$flexWrapMap = {
    wrap: (0, $2ZUkg.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $2ZUkg.css)({
        flexWrap: "nowrap"
    })
};
var $23642f9233274671$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        alignItems: "stretch"
    })
};
var $23642f9233274671$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $23642f9233274671$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $h4hoY.parseXcss)(xcss);
    return (0, $2ZUkg.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $23642f9233274671$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $igww8.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $igww8.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $igww8.spaceStylesMap).rowGap[rowGap],
            alignItems && $23642f9233274671$var$alignItemsMap[alignItems],
            direction && $23642f9233274671$var$flexDirectionMap[direction],
            justifyContent && $23642f9233274671$var$justifyContentMap[justifyContent],
            wrap && $23642f9233274671$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$23642f9233274671$var$Flex.displayName = "Flex";
var $23642f9233274671$export$2e2bcd8739ae039 = $23642f9233274671$var$Flex;

});


parcelRegister("gSxcF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c49b71f94a1a5f81$export$2e2bcd8739ae039; });

var $2eRSM = parcelRequire("2eRSM");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $h4hoY = parcelRequire("h4hoY");

var $32o0T = parcelRequire("32o0T");
var $c49b71f94a1a5f81$var$flexGrowMap = {
    hug: (0, $h4hoY.xcss)({
        flexGrow: 0
    }),
    fill: (0, $h4hoY.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $c49b71f94a1a5f81$var$Stack = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $c49b71f94a1a5f81$var$flexGrowMap[grow]
    ].concat((0, $2eRSM.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $2ZUkg.jsx)((0, $32o0T.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$c49b71f94a1a5f81$var$Stack.displayName = "Stack";
var $c49b71f94a1a5f81$export$2e2bcd8739ae039 = $c49b71f94a1a5f81$var$Stack;

});

parcelRegister("6eEpC", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", function () { return $48a365eafbd702e9$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $48a365eafbd702e9$export$9ca534b70725964d; });

var $iSvIT = parcelRequire("iSvIT");
var $48a365eafbd702e9$export$443076ec7ebce042 = /*#__PURE__*/ (0, $iSvIT.createContext)("cozy");
var $48a365eafbd702e9$export$9ca534b70725964d = /*#__PURE__*/ (0, $iSvIT.createContext)("border");

});



parcelRegister("lPJK3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe51d7c62fbd9cb6$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $KsdEf = parcelRequire("KsdEf");

var $4OZuI = parcelRequire("4OZuI");

var $3rBsW = parcelRequire("3rBsW");

var $jxLBU = parcelRequire("jxLBU");

var $hIRze = parcelRequire("hIRze");
var $fe51d7c62fbd9cb6$var$_excluded = [
    "component",
    "cssFn",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $fe51d7c62fbd9cb6$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $fe51d7c62fbd9cb6$var$CustomItem = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $4OZuI.default) : _ref$cssFn, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, $Zqzri.default)(_ref, $fe51d7c62fbd9cb6$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $iSvIT.useContext)((0, $3rBsW.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    (0, $KsdEf.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $4OZuI.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $2ZUkg.jsx)((0, $hIRze.default), (0, $y8mkn.default)({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: (0, $2ZUkg.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return (0, $2ZUkg.jsx)(Component, (0, $y8mkn.default)({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $fe51d7c62fbd9cb6$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $fe51d7c62fbd9cb6$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $fe51d7c62fbd9cb6$var$preventEvent : (0, $jxLBU.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $fe51d7c62fbd9cb6$export$2e2bcd8739ae039 = $fe51d7c62fbd9cb6$var$CustomItem;

});

parcelRegister("5EWjr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41edebd0e06fdafe$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $1AGo9 = parcelRequire("1AGo9");

var $KsdEf = parcelRequire("KsdEf");

var $4OZuI = parcelRequire("4OZuI");

var $3rBsW = parcelRequire("3rBsW");

var $jxLBU = parcelRequire("jxLBU");

var $hIRze = parcelRequire("hIRze");
var $41edebd0e06fdafe$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $41edebd0e06fdafe$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $41edebd0e06fdafe$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $41edebd0e06fdafe$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $41edebd0e06fdafe$var$LinkItem = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $4OZuI.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, $Zqzri.default)(props, $41edebd0e06fdafe$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $1AGo9.default)();
    var interactionContext = (0, $iSvIT.useContext)((0, $3rBsW.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === "string" && $41edebd0e06fdafe$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $41edebd0e06fdafe$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === "";
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : "a";
    (0, $KsdEf.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $4OZuI.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $2ZUkg.jsx)((0, $hIRze.default), (0, $y8mkn.default)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $2ZUkg.jsx)(Component, (0, $y8mkn.default)({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $41edebd0e06fdafe$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $41edebd0e06fdafe$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $41edebd0e06fdafe$var$preventEvent : (0, $jxLBU.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            "aria-current": isSelected ? "page" : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $41edebd0e06fdafe$export$2e2bcd8739ae039 = $41edebd0e06fdafe$var$LinkItem;

});
parcelRegister("1AGo9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $128a08b9c3cf4751$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $khj5Q = parcelRequire("khj5Q");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $128a08b9c3cf4751$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $iSvIT.useContext)((0, $khj5Q.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $128a08b9c3cf4751$export$2e2bcd8739ae039 = $128a08b9c3cf4751$var$useRouterLink;

});
parcelRegister("khj5Q", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $ec3434b51cedc35b$export$2931e0ee690eee88; });

var $iSvIT = parcelRequire("iSvIT");
var $ec3434b51cedc35b$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $iSvIT.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $ec3434b51cedc35b$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($ec3434b51cedc35b$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $ec3434b51cedc35b$export$2e2bcd8739ae039 = $ec3434b51cedc35b$var$RouterLinkProvider;

});



parcelRegister("lEdbm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc278f22dea73e1d$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $a8ppI = parcelRequire("a8ppI");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $fc278f22dea73e1d$var$useRegisterItemWithFocusManager() {
    var _useContext = (0, $iSvIT.useContext)((0, $a8ppI.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(function() {
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $fc278f22dea73e1d$export$2e2bcd8739ae039 = $fc278f22dea73e1d$var$useRegisterItemWithFocusManager;

});
parcelRegister("a8ppI", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", function () { return $760e5d5c2a67360f$export$f18c1d4fc7326096; });
$parcel$export(module.exports, "default", function () { return $760e5d5c2a67360f$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $4OZuI = parcelRequire("4OZuI");

var $5IwVv = parcelRequire("5IwVv");
var $760e5d5c2a67360f$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    menuItemRefs: [],
    registerRef: (0, $4OZuI.default)
});
/**
 * Focus manager logic
 */ var $760e5d5c2a67360f$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children;
    var menuItemRefs = (0, $iSvIT.useRef)([]);
    var registerRef = (0, $iSvIT.useCallback)(function(ref) {
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $iSvIT.useEffect)(function() {
        (0, $2e1kT.bind)(window, {
            type: "keydown",
            listener: (0, $5IwVv.default)(menuItemRefs.current)
        });
        var unbind = function unbind() {
            (0, $2e1kT.bind)(window, {
                type: "keydown",
                listener: (0, $5IwVv.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($760e5d5c2a67360f$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $760e5d5c2a67360f$export$2e2bcd8739ae039 = $760e5d5c2a67360f$var$FocusManager;

});
parcelRegister("5IwVv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $429a9a5650c72484$export$2e2bcd8739ae039; });

var $9Ecwd = parcelRequire("9Ecwd");

var $cDjyV = parcelRequire("cDjyV");
var $429a9a5650c72484$var$actionMap = (0, $9Ecwd.default)((0, $9Ecwd.default)((0, $9Ecwd.default)((0, $9Ecwd.default)({}, (0, $cDjyV.KEY_DOWN), "next"), (0, $cDjyV.KEY_UP), "prev"), (0, $cDjyV.KEY_HOME), "first"), (0, $cDjyV.KEY_END), "last");
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $429a9a5650c72484$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var isDisabled = refs[currentFocusedIdx + 1].getAttribute("disabled") !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $429a9a5650c72484$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var isDisabled = refs[currentFocusedIdx - 1].getAttribute("disabled") !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $429a9a5650c72484$export$2e2bcd8739ae039(refs) {
    return function(e) {
        var currentFocusedIdx = refs.findIndex(function(el) {
            var _document$activeEleme;
            return (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el);
        });
        var action = $429a9a5650c72484$var$actionMap[e.key];
        switch(action){
            case "next":
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    var _nextFocusableElement = $429a9a5650c72484$var$getNextFocusableElement(refs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                }
                break;
            case "prev":
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    var _prevFocusableElement = $429a9a5650c72484$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                }
                break;
            case "first":
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $429a9a5650c72484$var$getNextFocusableElement(refs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case "last":
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $429a9a5650c72484$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("akIMk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $785e81b8c442155f$export$2e2bcd8739ae039; });
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $f4dOm = parcelRequire("f4dOm");
var $785e81b8c442155f$var$gutter = "var(--ds-space-negative-050, -4px)";
var $785e81b8c442155f$var$listStyles = null;
var $785e81b8c442155f$var$listItemStyles = null;
var $785e81b8c442155f$var$Grid = function Grid(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref["aria-label"];
    return /*#__PURE__*/ $iSvIT.createElement("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $f4dOm.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ])
    }, (0, $iSvIT.Children).map(children, function(child) {
        return child && /*#__PURE__*/ $iSvIT.createElement("li", {
            className: (0, $f4dOm.default)([
                "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
            ])
        }, child);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$785e81b8c442155f$export$2e2bcd8739ae039 = $785e81b8c442155f$var$Grid;

});

parcelRegister("gY9aX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a95e0b6092d753$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $iSvIT = parcelRequire("iSvIT");

var $eVE6j = parcelRequire("eVE6j");

var $a8ppI = parcelRequire("a8ppI");
var $c5a95e0b6092d753$var$_excluded = [
    "children",
    "isLoading",
    "maxHeight",
    "maxWidth",
    "minHeight",
    "minWidth",
    "onClick",
    "role",
    "setInitialFocusRef",
    "spacing",
    "testId"
];
/**
 * It sets focus to the first avatar when popup is open.
 */ var $c5a95e0b6092d753$var$PopupAvatarGroup = function PopupAvatarGroup(_ref) {
    var children = _ref.children, isLoading = _ref.isLoading, maxHeight = _ref.maxHeight, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 800 : _ref$maxWidth, minHeight = _ref.minHeight, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 320 : _ref$minWidth, onClick = _ref.onClick, role = _ref.role, setInitialFocusRef = _ref.setInitialFocusRef, spacing = _ref.spacing, testId = _ref.testId, rest = (0, $Zqzri.default)(_ref, $c5a95e0b6092d753$var$_excluded);
    var _useContext = (0, $iSvIT.useContext)((0, $a8ppI.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    (0, $iSvIT.useEffect)(function() {
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eVE6j.default), (0, $y8mkn.default)({
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId
    }, rest), children);
};
var $c5a95e0b6092d753$export$2e2bcd8739ae039 = $c5a95e0b6092d753$var$PopupAvatarGroup;

});
parcelRegister("eVE6j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ade57ebf90d37e09$export$2e2bcd8739ae039; });

var $y8mkn = parcelRequire("y8mkn");

var $Zqzri = parcelRequire("Zqzri");

var $2ZUkg = parcelRequire("2ZUkg");

var $6eEpC = parcelRequire("6eEpC");
var $ade57ebf90d37e09$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $ade57ebf90d37e09$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    position: "static",
    flexDirection: "column",
    overflow: "auto"
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $ade57ebf90d37e09$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "cozy" : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, $Zqzri.default)(_ref, $ade57ebf90d37e09$var$_excluded);
    return (0, $2ZUkg.jsx)((0, $6eEpC.SpacingContext).Provider, {
        value: spacing
    }, (0, $2ZUkg.jsx)((0, $6eEpC.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, (0, $2ZUkg.jsx)("div", (0, $y8mkn.default)({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $ade57ebf90d37e09$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: UNSAFE_className
    }, rest))));
};
var $ade57ebf90d37e09$export$2e2bcd8739ae039 = $ade57ebf90d37e09$var$MenuGroup;

});


parcelRegister("kbnBK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb1725c5158c21db$export$2e2bcd8739ae039; });
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $y8mkn = parcelRequire("y8mkn");

var $9Ecwd = parcelRequire("9Ecwd");

var $iSvIT = parcelRequire("iSvIT");

var $f4dOm = parcelRequire("f4dOm");

var $jxLBU = parcelRequire("jxLBU");
var $eb1725c5158c21db$var$boxShadowCssVar = "--avatar-box-shadow";
var $eb1725c5158c21db$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh1ntv _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhkm7j4 _syaz1fxt _16qs1nhn _t9ec1aqe _1ejjglyw _mizu194a _ra3xnqa1 _1ah3yh40 _128myh40 _irr315ej _30l31fxt _1di6ip91 _9h8h1fxt _1q8w1np6 _jlxit94y",
    circle: "_2rko1q5u",
    active: "_bfhkfg4m _16qsqz53 _syazaqb7 _t9ec1np6 _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    disabled: "_80om13gf _1peqs237 _1hfkvuon"
};
var $eb1725c5158c21db$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $eb1725c5158c21db$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
var $eb1725c5158c21db$var$fontMap = {
    small: "_11c81vlj",
    medium: "_11c81vlj",
    large: "_11c8qk37",
    xlarge: "_11c81doa",
    xxlarge: "_11c81doa"
};
var $eb1725c5158c21db$var$MAX_DISPLAY_COUNT = 99;
var $eb1725c5158c21db$var$MoreIndicator = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "circle" : _ref$appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? (0, $jxLBU.fg)("platform-component-visual-refresh") ? "var(--ds-surface, #FFFFFF)" : "var(--ds-border-inverse, #FFFFFF)" : _ref$borderColor, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, _ref$count = _ref.count, count = _ref$count === void 0 ? 0 : _ref$count, testId = _ref.testId, onClick = _ref.onClick, ariaControls = _ref["aria-controls"], ariaExpanded = _ref["aria-expanded"], ariaHaspopup = _ref["aria-haspopup"], _ref$buttonProps = _ref.buttonProps, buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps, isActive = _ref.isActive;
    var onClickHander = (0, $iSvIT.useCallback)(function(event, analyticsEvent) {
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ $iSvIT.createElement("button", (0, $y8mkn.default)({
        type: "submit"
    }, buttonProps, {
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        style: (0, $9Ecwd.default)({}, $eb1725c5158c21db$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        className: (0, $f4dOm.default)([
            $eb1725c5158c21db$var$styles.root,
            $eb1725c5158c21db$var$borderRadiusMap[size],
            appearance === "circle" && $eb1725c5158c21db$var$styles.circle,
            $eb1725c5158c21db$var$widthHeightMap[size],
            $eb1725c5158c21db$var$fontMap[size],
            isActive && $eb1725c5158c21db$var$styles.active
        ])
    }), "+", count > $eb1725c5158c21db$var$MAX_DISPLAY_COUNT ? $eb1725c5158c21db$var$MAX_DISPLAY_COUNT : count);
});
$eb1725c5158c21db$var$MoreIndicator.displayName = "MoreIndicator";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eb1725c5158c21db$export$2e2bcd8739ae039 = $eb1725c5158c21db$var$MoreIndicator;

});

parcelRegister("cCyPX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93040e91c313e22a$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $f4dOm = parcelRequire("f4dOm");
var $93040e91c313e22a$var$listStyles = null;
var $93040e91c313e22a$var$listItemStyles = null;
var $93040e91c313e22a$var$Stack = function Stack(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref["aria-label"];
    return /*#__PURE__*/ $iSvIT.createElement("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $f4dOm.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ])
    }, (0, $iSvIT.Children).map(children, function(child) {
        return child && /*#__PURE__*/ $iSvIT.createElement("li", {
            className: (0, $f4dOm.default)([
                "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t"
            ])
        }, child);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$93040e91c313e22a$export$2e2bcd8739ae039 = $93040e91c313e22a$var$Stack;

});

parcelRegister("ajQGf", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", function () { return $78348af46c08234a$export$b067756944994c79; });
var $78348af46c08234a$export$b067756944994c79 = function composeUniqueKey(props, index) {
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("4199E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $b9DvP = parcelRequire("b9DvP");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $2ece5b5247d7fd0c$var$_interopRequireDefault($b9DvP).default;
    }
});
function $2ece5b5247d7fd0c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("b9DvP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $81ef2f52e6d5c559$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $j9CIH = parcelRequire("j9CIH");

var $i5UxU = parcelRequire("i5UxU");
function $81ef2f52e6d5c559$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $81ef2f52e6d5c559$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $81ef2f52e6d5c559$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $81ef2f52e6d5c559$var$NodeResolver = function(_Component) {
    $81ef2f52e6d5c559$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $81ef2f52e6d5c559$var$_classCallCheck(this, NodeResolver);
        return $81ef2f52e6d5c559$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $81ef2f52e6d5c559$var$_createClass(NodeResolver, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.innerRef((0, $i5UxU.findDOMNode)(this));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($j9CIH.Component);
module.exports.default = $81ef2f52e6d5c559$var$NodeResolver;

});
parcelRegister("j9CIH", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8ji0h"));

});
parcelRegister("8ji0h", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $60ce102d73463f1d$export$dca3b0875bd9a954; }, function (v) { return $60ce102d73463f1d$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $60ce102d73463f1d$export$16fa2f45be04daa8; }, function (v) { return $60ce102d73463f1d$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $60ce102d73463f1d$export$ffb0004e005737fa; }, function (v) { return $60ce102d73463f1d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $60ce102d73463f1d$export$e2c29f18771995cb; }, function (v) { return $60ce102d73463f1d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $60ce102d73463f1d$export$221d75b3f55bb0bd; }, function (v) { return $60ce102d73463f1d$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $60ce102d73463f1d$export$5f8d39834fd61797; }, function (v) { return $60ce102d73463f1d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $60ce102d73463f1d$export$74bf444e3cd11ea5; }, function (v) { return $60ce102d73463f1d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $60ce102d73463f1d$export$ae55be85d98224ed; }, function (v) { return $60ce102d73463f1d$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $60ce102d73463f1d$export$e530037191fcd5d7; }, function (v) { return $60ce102d73463f1d$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $60ce102d73463f1d$export$fd42f52fd3ae1109; }, function (v) { return $60ce102d73463f1d$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $60ce102d73463f1d$export$c8a8987d4410bf2d; }, function (v) { return $60ce102d73463f1d$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $60ce102d73463f1d$export$d38cd72104c1f0e9; }, function (v) { return $60ce102d73463f1d$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $60ce102d73463f1d$export$7d1e3a5e95ceca43; }, function (v) { return $60ce102d73463f1d$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $60ce102d73463f1d$export$257a8862b851cb5b; }, function (v) { return $60ce102d73463f1d$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $60ce102d73463f1d$export$a8257692ac88316c; }, function (v) { return $60ce102d73463f1d$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $60ce102d73463f1d$export$488013bae63b21da; }, function (v) { return $60ce102d73463f1d$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $60ce102d73463f1d$export$7c73462e0d25e514; }, function (v) { return $60ce102d73463f1d$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $60ce102d73463f1d$export$7568632d0d33d16d; }, function (v) { return $60ce102d73463f1d$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $60ce102d73463f1d$export$88948ce120ea2619; }, function (v) { return $60ce102d73463f1d$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $60ce102d73463f1d$export$35808ee640e87ca7; }, function (v) { return $60ce102d73463f1d$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $60ce102d73463f1d$export$fae74005e78b1a27; }, function (v) { return $60ce102d73463f1d$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $60ce102d73463f1d$export$dc8fbce3eb94dc1e; }, function (v) { return $60ce102d73463f1d$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $60ce102d73463f1d$export$6a7bc4e911dc01cf; }, function (v) { return $60ce102d73463f1d$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $60ce102d73463f1d$export$6d9c69b0de29b591; }, function (v) { return $60ce102d73463f1d$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $60ce102d73463f1d$export$f680877a34711e37; }, function (v) { return $60ce102d73463f1d$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $60ce102d73463f1d$export$d5a552a76deda3c2; }, function (v) { return $60ce102d73463f1d$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $60ce102d73463f1d$export$aaabe4eda9ed9969; }, function (v) { return $60ce102d73463f1d$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $60ce102d73463f1d$export$e5c5a5f917a5871c; }, function (v) { return $60ce102d73463f1d$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $60ce102d73463f1d$export$1538c33de8887b59; }, function (v) { return $60ce102d73463f1d$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $60ce102d73463f1d$export$13e3392192263954; }, function (v) { return $60ce102d73463f1d$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $60ce102d73463f1d$export$b8f5890fc79d6aca; }, function (v) { return $60ce102d73463f1d$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $60ce102d73463f1d$export$60241385465d0a34; }, function (v) { return $60ce102d73463f1d$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $60ce102d73463f1d$export$306c0aa65ff9ec16; }, function (v) { return $60ce102d73463f1d$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $60ce102d73463f1d$export$7b286972b8d8ccbf; }, function (v) { return $60ce102d73463f1d$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $60ce102d73463f1d$export$83d89fbfd8236492; }, function (v) { return $60ce102d73463f1d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $60ce102d73463f1d$export$dca3b0875bd9a954;
var $60ce102d73463f1d$export$16fa2f45be04daa8;
var $60ce102d73463f1d$export$ffb0004e005737fa;
var $60ce102d73463f1d$export$e2c29f18771995cb;
var $60ce102d73463f1d$export$221d75b3f55bb0bd;
var $60ce102d73463f1d$export$5f8d39834fd61797;
var $60ce102d73463f1d$export$74bf444e3cd11ea5;
var $60ce102d73463f1d$export$ae55be85d98224ed;
var $60ce102d73463f1d$export$e530037191fcd5d7;
var $60ce102d73463f1d$export$fd42f52fd3ae1109;
var $60ce102d73463f1d$export$c8a8987d4410bf2d;
var $60ce102d73463f1d$export$d38cd72104c1f0e9;
var $60ce102d73463f1d$export$7d1e3a5e95ceca43;
var $60ce102d73463f1d$export$257a8862b851cb5b;
var $60ce102d73463f1d$export$a8257692ac88316c;
var $60ce102d73463f1d$export$488013bae63b21da;
var $60ce102d73463f1d$export$7c73462e0d25e514;
var $60ce102d73463f1d$export$7568632d0d33d16d;
var $60ce102d73463f1d$export$88948ce120ea2619;
var $60ce102d73463f1d$export$35808ee640e87ca7;
var $60ce102d73463f1d$export$fae74005e78b1a27;
var $60ce102d73463f1d$export$dc8fbce3eb94dc1e;
var $60ce102d73463f1d$export$6a7bc4e911dc01cf;
var $60ce102d73463f1d$export$6d9c69b0de29b591;
var $60ce102d73463f1d$export$f680877a34711e37;
var $60ce102d73463f1d$export$d5a552a76deda3c2;
var $60ce102d73463f1d$export$aaabe4eda9ed9969;
var $60ce102d73463f1d$export$e5c5a5f917a5871c;
var $60ce102d73463f1d$export$1538c33de8887b59;
var $60ce102d73463f1d$export$13e3392192263954;
var $60ce102d73463f1d$export$b8f5890fc79d6aca;
var $60ce102d73463f1d$export$60241385465d0a34;
var $60ce102d73463f1d$export$306c0aa65ff9ec16;
var $60ce102d73463f1d$export$7b286972b8d8ccbf;
var $60ce102d73463f1d$export$83d89fbfd8236492;
"use strict";
var $60ce102d73463f1d$var$l = Symbol.for("react.element"), $60ce102d73463f1d$var$n = Symbol.for("react.portal"), $60ce102d73463f1d$var$p = Symbol.for("react.fragment"), $60ce102d73463f1d$var$q = Symbol.for("react.strict_mode"), $60ce102d73463f1d$var$r = Symbol.for("react.profiler"), $60ce102d73463f1d$var$t = Symbol.for("react.provider"), $60ce102d73463f1d$var$u = Symbol.for("react.context"), $60ce102d73463f1d$var$v = Symbol.for("react.forward_ref"), $60ce102d73463f1d$var$w = Symbol.for("react.suspense"), $60ce102d73463f1d$var$x = Symbol.for("react.memo"), $60ce102d73463f1d$var$y = Symbol.for("react.lazy"), $60ce102d73463f1d$var$z = Symbol.iterator;
function $60ce102d73463f1d$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $60ce102d73463f1d$var$z && a[$60ce102d73463f1d$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $60ce102d73463f1d$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $60ce102d73463f1d$var$C = Object.assign, $60ce102d73463f1d$var$D = {};
function $60ce102d73463f1d$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $60ce102d73463f1d$var$D;
    this.updater = e || $60ce102d73463f1d$var$B;
}
$60ce102d73463f1d$var$E.prototype.isReactComponent = {};
$60ce102d73463f1d$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$60ce102d73463f1d$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $60ce102d73463f1d$var$F() {}
$60ce102d73463f1d$var$F.prototype = $60ce102d73463f1d$var$E.prototype;
function $60ce102d73463f1d$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $60ce102d73463f1d$var$D;
    this.updater = e || $60ce102d73463f1d$var$B;
}
var $60ce102d73463f1d$var$H = $60ce102d73463f1d$var$G.prototype = new $60ce102d73463f1d$var$F;
$60ce102d73463f1d$var$H.constructor = $60ce102d73463f1d$var$G;
$60ce102d73463f1d$var$C($60ce102d73463f1d$var$H, $60ce102d73463f1d$var$E.prototype);
$60ce102d73463f1d$var$H.isPureReactComponent = !0;
var $60ce102d73463f1d$var$I = Array.isArray, $60ce102d73463f1d$var$J = Object.prototype.hasOwnProperty, $60ce102d73463f1d$var$K = {
    current: null
}, $60ce102d73463f1d$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $60ce102d73463f1d$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$60ce102d73463f1d$var$J.call(b, d) && !$60ce102d73463f1d$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $60ce102d73463f1d$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $60ce102d73463f1d$var$K.current
    };
}
function $60ce102d73463f1d$var$N(a, b) {
    return {
        $$typeof: $60ce102d73463f1d$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $60ce102d73463f1d$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $60ce102d73463f1d$var$l;
}
function $60ce102d73463f1d$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $60ce102d73463f1d$var$P = /\/+/g;
function $60ce102d73463f1d$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $60ce102d73463f1d$var$escape("" + a.key) : b.toString(36);
}
function $60ce102d73463f1d$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $60ce102d73463f1d$var$l:
                case $60ce102d73463f1d$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $60ce102d73463f1d$var$Q(h, 0) : d, $60ce102d73463f1d$var$I(c) ? (e = "", null != a && (e = a.replace($60ce102d73463f1d$var$P, "$&/") + "/"), $60ce102d73463f1d$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($60ce102d73463f1d$var$O(c) && (c = $60ce102d73463f1d$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($60ce102d73463f1d$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($60ce102d73463f1d$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $60ce102d73463f1d$var$Q(k, g);
        h += $60ce102d73463f1d$var$R(k, b, e, f, c);
    }
    else if (f = $60ce102d73463f1d$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $60ce102d73463f1d$var$Q(k, g++), h += $60ce102d73463f1d$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $60ce102d73463f1d$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $60ce102d73463f1d$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $60ce102d73463f1d$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $60ce102d73463f1d$var$U = {
    current: null
}, $60ce102d73463f1d$var$V = {
    transition: null
}, $60ce102d73463f1d$var$W = {
    ReactCurrentDispatcher: $60ce102d73463f1d$var$U,
    ReactCurrentBatchConfig: $60ce102d73463f1d$var$V,
    ReactCurrentOwner: $60ce102d73463f1d$var$K
};
$60ce102d73463f1d$export$dca3b0875bd9a954 = {
    map: $60ce102d73463f1d$var$S,
    forEach: function(a, b, e) {
        $60ce102d73463f1d$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $60ce102d73463f1d$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $60ce102d73463f1d$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$60ce102d73463f1d$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$60ce102d73463f1d$export$16fa2f45be04daa8 = $60ce102d73463f1d$var$E;
$60ce102d73463f1d$export$ffb0004e005737fa = $60ce102d73463f1d$var$p;
$60ce102d73463f1d$export$e2c29f18771995cb = $60ce102d73463f1d$var$r;
$60ce102d73463f1d$export$221d75b3f55bb0bd = $60ce102d73463f1d$var$G;
$60ce102d73463f1d$export$5f8d39834fd61797 = $60ce102d73463f1d$var$q;
$60ce102d73463f1d$export$74bf444e3cd11ea5 = $60ce102d73463f1d$var$w;
$60ce102d73463f1d$export$ae55be85d98224ed = $60ce102d73463f1d$var$W;
$60ce102d73463f1d$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $60ce102d73463f1d$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $60ce102d73463f1d$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$60ce102d73463f1d$var$J.call(b, f) && !$60ce102d73463f1d$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $60ce102d73463f1d$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$60ce102d73463f1d$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $60ce102d73463f1d$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $60ce102d73463f1d$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$60ce102d73463f1d$export$c8a8987d4410bf2d = $60ce102d73463f1d$var$M;
$60ce102d73463f1d$export$d38cd72104c1f0e9 = function(a) {
    var b = $60ce102d73463f1d$var$M.bind(null, a);
    b.type = a;
    return b;
};
$60ce102d73463f1d$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$60ce102d73463f1d$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $60ce102d73463f1d$var$v,
        render: a
    };
};
$60ce102d73463f1d$export$a8257692ac88316c = $60ce102d73463f1d$var$O;
$60ce102d73463f1d$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $60ce102d73463f1d$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $60ce102d73463f1d$var$T
    };
};
$60ce102d73463f1d$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $60ce102d73463f1d$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$60ce102d73463f1d$export$7568632d0d33d16d = function(a) {
    var b = $60ce102d73463f1d$var$V.transition;
    $60ce102d73463f1d$var$V.transition = {};
    try {
        a();
    } finally{
        $60ce102d73463f1d$var$V.transition = b;
    }
};
$60ce102d73463f1d$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$60ce102d73463f1d$export$35808ee640e87ca7 = function(a, b) {
    return $60ce102d73463f1d$var$U.current.useCallback(a, b);
};
$60ce102d73463f1d$export$fae74005e78b1a27 = function(a) {
    return $60ce102d73463f1d$var$U.current.useContext(a);
};
$60ce102d73463f1d$export$dc8fbce3eb94dc1e = function() {};
$60ce102d73463f1d$export$6a7bc4e911dc01cf = function(a) {
    return $60ce102d73463f1d$var$U.current.useDeferredValue(a);
};
$60ce102d73463f1d$export$6d9c69b0de29b591 = function(a, b) {
    return $60ce102d73463f1d$var$U.current.useEffect(a, b);
};
$60ce102d73463f1d$export$f680877a34711e37 = function() {
    return $60ce102d73463f1d$var$U.current.useId();
};
$60ce102d73463f1d$export$d5a552a76deda3c2 = function(a, b, e) {
    return $60ce102d73463f1d$var$U.current.useImperativeHandle(a, b, e);
};
$60ce102d73463f1d$export$aaabe4eda9ed9969 = function(a, b) {
    return $60ce102d73463f1d$var$U.current.useInsertionEffect(a, b);
};
$60ce102d73463f1d$export$e5c5a5f917a5871c = function(a, b) {
    return $60ce102d73463f1d$var$U.current.useLayoutEffect(a, b);
};
$60ce102d73463f1d$export$1538c33de8887b59 = function(a, b) {
    return $60ce102d73463f1d$var$U.current.useMemo(a, b);
};
$60ce102d73463f1d$export$13e3392192263954 = function(a, b, e) {
    return $60ce102d73463f1d$var$U.current.useReducer(a, b, e);
};
$60ce102d73463f1d$export$b8f5890fc79d6aca = function(a) {
    return $60ce102d73463f1d$var$U.current.useRef(a);
};
$60ce102d73463f1d$export$60241385465d0a34 = function(a) {
    return $60ce102d73463f1d$var$U.current.useState(a);
};
$60ce102d73463f1d$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $60ce102d73463f1d$var$U.current.useSyncExternalStore(a, b, e);
};
$60ce102d73463f1d$export$7b286972b8d8ccbf = function() {
    return $60ce102d73463f1d$var$U.current.useTransition();
};
$60ce102d73463f1d$export$83d89fbfd8236492 = "18.2.0";

});





//# sourceMappingURL=jira-switcher.81935ac4.js.map
